import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NebenkostenArtikelPickerDialogComponent } from './nebenkosten-artikel-picker-dialog.component';
import { NebenkostenLieferantPickerDialogComponent } from './nebenkosten-lieferant-picker-dialog.component';
import { NebenkostenPrimanotaVorschauDialogComponent } from './nebenkosten-primanota-vorschau-dialog.component';
import {
    PrimanotaExportVorschauData,
    PrimanotaExportVorschauZeile,
    PrimanotaExportVorschauVariante,
} from './nebenkosten-primanota-vorschau-dialog.models';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Tierarzt } from '../../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import { Material } from '../../../warehouse/material/material';
import { Supplier } from '../../../warehouse/supplier/supplier';
import { GemeinkostenInvoiceKiService } from './gemeinkosten-invoice-ki.service';
import { WawiInvoiceDraftDto, WawiInvoiceReviewDialogData } from './gemeinkosten-invoice.models';
import {
    defaultKfzSachkonto,
    FIBU_HONORAR_KOSTENARTEN,
    FIBU_KOSTENARTEN,
    FIBU_MWST_SAETZE,
    Gemeinkosten,
    GemeinkostenPosition,
    isFibuFahrzeugKontext,
    kfzSachkontoFromArtikel,
    kfzSuffixForFahrzeug,
    nettoFromBrutto,
    normalizeMwstSatz,
    preferredAufwandKontoNr,
    kfzKontoNr,
    mwstEuroForTargetBrutto,
    roundEuro2,
} from '../gemeinkosten';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'kiene-gemeinkosten-invoice-review-dialog',
    templateUrl: './gemeinkosten-invoice-review-dialog.component.html',
    styleUrls: ['./gemeinkosten-invoice-review-dialog.component.scss'],
})
export class GemeinkostenInvoiceReviewDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('formPane') formPane?: ElementRef<HTMLElement>;
    @ViewChild('pdfPane') pdfPane?: ElementRef<HTMLElement>;

    pdfSrc: string | Uint8Array | null = null;
    pdfLoading = false;
    private objectUrl: string | null = null;
    private pdfBytes: Uint8Array | null = null;
    private pdfErrorRetried = false;
    page = 1;
    totalPages = 0;
    private pdfResizeObserver?: ResizeObserver;
    private pdfRelayoutTimer?: ReturnType<typeof setTimeout>;

    gemeinkostenTypCtrl = new FormControl(0);
    datumCtrl = new FormControl();
    kommentarCtrl = new FormControl('');
    rechnungNummerCtrl = new FormControl('');
    leistungsdatumVonCtrl = new FormControl();
    leistungsdatumBisCtrl = new FormControl();

    supplier: Supplier;
    tierarzt: Tierarzt;
    positionen: GemeinkostenPosition[] = [];
    positionArtikel: Material[] = [];
    positionFahrzeuge: any[] = [];
    positionHonorarTas: any[] = [];
    positionTieraerzte: Tierarzt[] = [];

    artikelParams = new HttpParams().set('nebenkosten', '1').set('honorar', '0');
    lieferantParams = new HttpParams().set('nebenkosten', '1');
    fahrzeugParams = new HttpParams().set('aktiv', '1');
    honorarTaParams = new HttpParams().set('aktiv', '1');
    get kostenarten() {
        return this.nurHonorar ? FIBU_HONORAR_KOSTENARTEN : FIBU_KOSTENARTEN;
    }
    mwstSaetze = FIBU_MWST_SAETZE;

    /** Manuell: „das war fürs Auto“ → Fahrzeug/Kostenart anzeigen. */
    fahrzeugManuell = false;
    /** Wie früher: Positionen ausblenden, nur Gesamtbetrag speichern. */
    nurGesamtbetrag = false;
    gesamtNetto: number = 0;
    /** MwSt-Betrag in € (nicht %-Satz). */
    gesamtMwstEuro: number = 0;
    /** MwSt-% für Gesamtbetrag-Modus (wie Positionszeile). */
    gesamtMwstsatz = 19;
    gesamtArtikel: Material = null;
    gesamtBezeichnung = '';
    gesamtFahrzeug: any = null;
    gesamtHonorarTa: any = null;
    gesamtSachkonto: string = null;
    gesamtKontoNr: string = null;
    gesamtFibuAufwandKontoId: number = null;
    gesamtKostenstelleSuffix: string = null;
    gesamtKennzeichen: string = null;
    gesamtTierarzt: Tierarzt = null;
    private positionenVorGesamt: GemeinkostenPosition[] | null = null;
    private artikelVorGesamt: Material[] | null = null;

    /** Rabatt (Netto) zum anteiligen Verteilen auf Positionen. */
    rabattNetto: number = null;
    /** Snapshot der Netto-Werte vor letzter Rabatt-Verteilung (Undo). */
    nettoVorRabatt: number[] | null = null;

    saving = false;
    warnings: string[] = [];
    /** Positionen-Pagination (ab >20 Zeilen blättern). */
    readonly posPageSize = 20;
    posPage = 0;
    /** Snapshot beim Öffnen – für Korrektur-Log (Lernen). */
    private beforeSnapshot: Record<string, unknown> | null = null;

    constructor(
        public dialogRef: MatDialogRef<GemeinkostenInvoiceReviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: WawiInvoiceReviewDialogData,
        private readonly kiService: GemeinkostenInvoiceKiService,
        private readonly messageService: MessageService,
        private readonly http: HttpClient,
        private readonly api: KieneBackendApiService,
        private readonly dialog: MatDialog,
        private readonly cdr: ChangeDetectorRef,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        const d = this.data.draft;
        const g = this.data.gemeinkosten;
        this.warnings = [...(d?.warnings ?? [])];

        if (this.data.nurHonorar) {
            this.artikelParams = new HttpParams().set('honorar', '1');
            this.lieferantParams = new HttpParams();
            this.nurGesamtbetrag = true;
            this.fahrzeugManuell = false;
            // Honorare sind personenbezogen – Typ „Tierarzt“ als Default
            this.gemeinkostenTypCtrl.setValue(2);
        }

        if (this.data.pdfFile) {
            this.objectUrl = URL.createObjectURL(this.data.pdfFile);
            this.initPdfViewer();
        } else {
            this.pdfSrc = null;
            this.pdfLoading = false;
            if (this.data.mode !== 'edit') {
                this.warnings.push('PDF nicht verfügbar – bitte Beträge und Positionen anhand der Quittung prüfen.');
            }
        }

        if (g?.kosten_id) {
            this.gemeinkostenTypCtrl.setValue(
                this.data.nurHonorar ? 2 : g.tierarzt_id ? 2 : Number(g.labor) > 0 ? 1 : 0,
            );
            this.rechnungNummerCtrl.setValue(g.rechnung_nr ?? d.suggestedRechnungNr ?? '');
            this.kommentarCtrl.setValue(this.stripBelegIdSuffix(g.kommentar ?? d.kommentar ?? ''));
            if (g.datum) {
                this.datumCtrl.setValue(this.parseDateOnly(g.datum));
            } else if (d.suggestedDatum) {
                this.datumCtrl.setValue(this.parseDateOnly(d.suggestedDatum));
            }
            if (g.leistungsdatum_von) {
                this.leistungsdatumVonCtrl.setValue(this.parseDateOnly(g.leistungsdatum_von));
            } else if (d.suggestedLeistungsdatumVon) {
                this.leistungsdatumVonCtrl.setValue(this.parseDateOnly(d.suggestedLeistungsdatumVon));
            }
            if (g.leistungsdatum_bis) {
                this.leistungsdatumBisCtrl.setValue(this.parseDateOnly(g.leistungsdatum_bis));
            } else if (d.suggestedLeistungsdatumBis) {
                this.leistungsdatumBisCtrl.setValue(this.parseDateOnly(d.suggestedLeistungsdatumBis));
            }
            this.ensureLeistungsdatumFromRechnung();
            if (g.lieferant_id || g.lieferant) {
                this.supplier = {
                    lieferant_id: g.lieferant_id,
                    bezeichnung: g.lieferant,
                } as Supplier;
            }
            if (g.tierarzt_id) {
                this.tierarzt = Object.assign(new Tierarzt(), {
                    tierarzt_id: g.tierarzt_id,
                    nachname: g.tierarzt ?? '',
                });
            }
            this.initPositionenFromKosten(g);
            if (this.data.nurHonorar) {
                this.ensureHonorarArtikel(g);
                this.enterGesamtbetragMode();
                this.ensureHonorarArtikel(g);
                this.ensureHonorarTierarztFromDraft(d, g);
            }
            this.beforeSnapshot = this.captureBeforeSnapshot();
            this.hydrateSupplierFibu(() => this.resolveMissingAufwandKonten());
            return;
        }

        this.gemeinkostenTypCtrl.setValue(d.suggestedTyp ?? 0);
        this.rechnungNummerCtrl.setValue(d.suggestedRechnungNr ?? '');
        this.kommentarCtrl.setValue(this.stripBelegIdSuffix(d.kommentar ?? ''));
        if (d.suggestedDatum) {
            this.datumCtrl.setValue(this.parseDateOnly(d.suggestedDatum));
        }
        if (d.suggestedLeistungsdatumVon) {
            this.leistungsdatumVonCtrl.setValue(this.parseDateOnly(d.suggestedLeistungsdatumVon));
        }
        if (d.suggestedLeistungsdatumBis) {
            this.leistungsdatumBisCtrl.setValue(this.parseDateOnly(d.suggestedLeistungsdatumBis));
        }
        this.ensureLeistungsdatumFromRechnung();
        if (d.suggestedLieferantId || d.suggestedLieferantName) {
            this.supplier = {
                lieferant_id: d.suggestedLieferantId,
                bezeichnung: d.suggestedLieferantName,
            } as Supplier;
        }
        if (d.suggestedTierarztId) {
            this.tierarzt = Object.assign(new Tierarzt(), {
                tierarzt_id: d.suggestedTierarztId,
                nachname: d.suggestedTierarztName ?? '',
            });
        }
        this.initPositionenFromDraft();
        if (this.data.nurHonorar) {
            this.ensureHonorarArtikel(g);
            this.enterGesamtbetragMode();
            this.ensureHonorarArtikel(g);
            this.ensureHonorarTierarztFromDraft(d, g);
        }
        this.beforeSnapshot = this.captureBeforeSnapshot();
        this.hydrateSupplierFibu(() => this.resolveMissingAufwandKonten());
    }

    /**
     * Honorare: Artikel immer Honorar-Stamm (Kopf), nie OCR-Nebenkosten wie „Diverse Weiterberechnungen“.
     */
    private ensureHonorarArtikel(g?: Gemeinkosten | null): void {
        if (!this.nurHonorar) {
            return;
        }
        const artId = Number(g?.artikel_id || 0) || null;
        const artMe = (g?.artikel_me || '').trim() || 'Honorare und Gehälter';
        if (!artId) {
            return;
        }
        const m = {
            artikel_id: artId,
            artikel_me: artMe,
            buchungskonto: '4760',
        } as unknown as Material;
        this.gesamtArtikel = m;
        this.positionen.forEach((p, i) => {
            p.artikel_id = artId;
            p.artikel_me = artMe;
            p.artikel_buchungskonto = '4760';
            this.positionArtikel[i] = m;
        });
        this.syncAutocompleteHelpers();
        if (this.nurGesamtbetrag) {
            this.gesamtArtikel = m;
            this.resolveGesamtKonto();
        }
    }

    /** OCR mappt den TA oft als „Lieferant“ – für Honorare auf Tierarzt-Kopf legen. */
    private ensureHonorarTierarztFromDraft(d: WawiInvoiceDraftDto, g?: Gemeinkosten | null): void {
        if (this.tierarzt?.tierarzt_id) {
            this.gemeinkostenTypCtrl.setValue(2);
            return;
        }
        if (g?.tierarzt_id) {
            this.tierarzt = Object.assign(new Tierarzt(), {
                tierarzt_id: g.tierarzt_id,
                nachname: g.tierarzt ?? '',
            });
            this.gemeinkostenTypCtrl.setValue(2);
            return;
        }
        const name = (
            d?.suggestedTierarztName ||
            d?.suggestedLieferantName ||
            this.supplier?.bezeichnung ||
            ''
        ).trim();
        if (!name || /umsatzsteuer|provision|medikament/i.test(name)) {
            this.gemeinkostenTypCtrl.setValue(2);
            return;
        }
        this.gemeinkostenTypCtrl.setValue(2);
        const params = new HttpParams().set('search', name).set('limit', '10').set('offset', '0');
        this.api.get(this.apiBaseUrl + 'tierarzt/read.php', params).subscribe({
            next: (res: any) => {
                const records: any[] = res?.records || [];
                const norm = (s: string) =>
                    (s || '')
                        .toLowerCase()
                        .replace(/\b(dr\.?|prof\.?|tierarzt)\b/g, '')
                        .replace(/\s+/g, ' ')
                        .trim();
                const needle = norm(name);
                const hit =
                    records.find(r => {
                        const full = norm(`${r.titel || ''}${r.vorname || ''} ${r.nachname || ''}`);
                        return full && (full.includes(needle) || needle.includes(full) || needle.includes(norm(r.nachname || '')));
                    }) || records[0];
                if (hit?.tierarzt_id) {
                    this.tierarzt = Object.assign(new Tierarzt(), hit);
                    this.cdr.detectChanges();
                }
            },
            error: () => {},
        });
    }

    /**
     * yyyy-MM-dd / ISO ohne TZ-Verschiebung (sonst 10.04. → 09.04. im Datepicker).
     */
    private parseDateOnly(v: unknown): Date | null {
        if (v == null || v === '') {
            return null;
        }
        if (v instanceof Date && !Number.isNaN(v.getTime())) {
            return new Date(v.getFullYear(), v.getMonth(), v.getDate(), 12, 0, 0);
        }
        const s = String(v).trim();
        const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
        if (iso) {
            return new Date(+iso[1], +iso[2] - 1, +iso[3], 12, 0, 0);
        }
        const de = /^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/.exec(s);
        if (de) {
            let y = +de[3];
            if (y < 100) {
                y += y >= 70 ? 1900 : 2000;
            }
            return new Date(y, +de[2] - 1, +de[1], 12, 0, 0);
        }
        const d = new Date(s);
        if (Number.isNaN(d.getTime())) {
            return null;
        }
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0);
    }

    /** Kein Leistungsdatum → Rechnungsdatum (Festlegung). */
    private ensureLeistungsdatumFromRechnung() {
        if (this.leistungsdatumVonCtrl.value) {
            return;
        }
        const rd = this.datumCtrl.value;
        if (rd) {
            this.leistungsdatumVonCtrl.setValue(rd);
        }
    }

    private captureBeforeSnapshot(): Record<string, unknown> {
        const d = this.data.draft;
        const g = this.data.gemeinkosten;
        return {
            source: g?.kosten_id ? 'kosten' : 'draft',
            extract: d.extract ?? null,
            suggested: {
                lieferantId: d.suggestedLieferantId ?? g?.lieferant_id ?? null,
                lieferantName: d.suggestedLieferantName ?? g?.lieferant ?? null,
                lieferantNameOcr: d.extract?.lieferantName ?? d.suggestedLieferantName ?? null,
                artikelId: d.suggestedArtikelId ?? g?.artikel_id ?? null,
                artikelMe: d.suggestedArtikelMe ?? g?.artikel_me ?? null,
                tierarztId: d.suggestedTierarztId ?? g?.tierarzt_id ?? null,
                typ: d.suggestedTyp ?? null,
                rechnungNr: d.suggestedRechnungNr ?? g?.rechnung_nr ?? null,
                datum: d.suggestedDatum ?? g?.datum ?? null,
                kommentar: d.kommentar ?? g?.kommentar ?? null,
            },
            positionen: this.positionen.map((p, idx) => ({
                position: idx + 1,
                bezeichnung: p.bezeichnung,
                bezeichnungOcr: p.bezeichnung,
                artikelId: p.artikel_id,
                artikelBezeichnung: p.artikel_me,
                kosten_netto: p.kosten_netto,
                mwstsatz: p.mwstsatz,
                fibu_fahrzeug_id: p.fibu_fahrzeug_id,
                kennzeichen: p.kennzeichen,
                sachkonto: p.sachkonto,
                fibu_aufwand_konto_id: p.fibu_aufwand_konto_id,
                tierarzt_id: p.tierarzt_id,
                verteilungsart: p.verteilungsart,
            })),
        };
    }

    ngAfterViewInit(): void {
        const pane = this.pdfPane?.nativeElement;
        if (pane && typeof ResizeObserver !== 'undefined') {
            this.pdfResizeObserver = new ResizeObserver(() => this.schedulePdfRelayout());
            this.pdfResizeObserver.observe(pane);
        }
        this.schedulePdfRelayout(80);
    }

    ngOnDestroy(): void {
        this.pdfResizeObserver?.disconnect();
        if (this.pdfRelayoutTimer != null) {
            clearTimeout(this.pdfRelayoutTimer);
        }
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
        }
    }

    /** ng2-pdf-viewer fit-to-page braucht oft einen zweiten Layout-Pass (Resize). */
    private schedulePdfRelayout(delayMs = 0): void {
        if (this.pdfRelayoutTimer != null) {
            clearTimeout(this.pdfRelayoutTimer);
        }
        this.pdfRelayoutTimer = setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            this.cdr.detectChanges();
        }, delayMs);
    }

    private initPositionenFromKosten(g: NonNullable<WawiInvoiceReviewDialogData['gemeinkosten']>) {
        const fromKosten = Array.isArray(g.positionen) ? g.positionen : [];
        const fromDraft = Array.isArray(this.data.draft?.positionen) ? this.data.draft.positionen : [];
        // Kosten bevorzugt, wenn Konto/Suffix schon da (Draft hat oft nur fibuAufwandKontoId ohne konto_nr)
        const kostenOk =
            fromKosten.length > 0 &&
            (this.countKontoInRaw(fromKosten) > 0 ||
                this.countFahrzeugeInRaw(fromKosten) >= this.countFahrzeugeInRaw(fromDraft));
        const raw = kostenOk
            ? fromKosten
            : fromDraft.length > 0
              ? fromDraft
              : fromKosten;
        if (raw.length > 0) {
            this.positionen = raw.map(r => this.mapApiPosition(r));
            // Draft-Fahrzeuge nachziehen, falls Kosten-Zeile ohne Fz
            if (kostenOk && fromDraft.length > 0) {
                this.overlayDraftFahrzeuge(fromDraft);
            }
        } else {
            const preise = g.preise?.length ? g.preise : this.data.draft.preise ?? [];
            this.positionen =
                preise.length > 0
                    ? preise.map(p => {
                          const pos = this.newPosition();
                          pos.kosten_netto = (p as any).kosten_netto ?? (p as any).kostenNetto ?? 0;
                          pos.mwstsatz = normalizeMwstSatz((p as any).mwstsatz ?? 19);
                          if (g.artikel_id) {
                              pos.artikel_id = g.artikel_id;
                              pos.artikel_me = g.artikel_me;
                          }
                          return pos;
                      })
                    : [this.newPosition()];
        }
        this.syncAutocompleteHelpers();
        this.fahrzeugManuell = this.positionen.some(
            p => !!p.fibu_fahrzeug_id || p.verteilungsart === 'FAHRZEUG_TA' || !!p.sachkonto,
        );
        // Nur bei genau einem TA über alle Positionen Kopf auf Tierarzt – Flottenbelege (viele TAs) bleiben Allgemein
        this.syncKopfFromPositionenIfSingleTa();
    }

    private countFahrzeugeInRaw(rows: any[]): number {
        return (rows || []).filter(
            r => Number(r?.fibu_fahrzeug_id ?? r?.fibuFahrzeugId ?? 0) > 0 || !!(r?.kennzeichen || '').trim(),
        ).length;
    }

    private countKontoInRaw(rows: any[]): number {
        return (rows || []).filter(
            r =>
                !!(r?.konto_nr || r?.kontoNr) ||
                Number(r?.fibu_aufwand_konto_id ?? r?.fibuAufwandKontoId ?? 0) > 0,
        ).length;
    }

    /** Draft-Zeilen können frischere Fz/KZ haben – Konto/Suffix aus Kosten behalten. */
    private overlayDraftFahrzeuge(fromDraft: any[]) {
        const n = Math.min(this.positionen.length, fromDraft.length);
        for (let i = 0; i < n; i++) {
            const p = this.positionen[i];
            const d = fromDraft[i];
            if (!d) {
                continue;
            }
            const fzId = Number(d.fibu_fahrzeug_id ?? d.fibuFahrzeugId ?? 0) || null;
            const kz = (d.kennzeichen || d.kennzeichenHint || '').trim();
            if (!p.fibu_fahrzeug_id && fzId) {
                p.fibu_fahrzeug_id = fzId;
                p.kennzeichen = kz || p.kennzeichen;
                p.verteilungsart = 'FAHRZEUG_TA';
                if (!p.sachkonto && d.sachkonto) {
                    p.sachkonto = d.sachkonto;
                }
                if (!p.tierarzt_id && d.tierarztId) {
                    p.tierarzt_id = Number(d.tierarztId) || null;
                    p.tierarzt = d.tierarztName || p.tierarzt;
                }
            } else if (!p.kennzeichen && kz) {
                p.kennzeichen = kz;
            }
        }
    }

    private initPositionenFromDraft() {
        const d = this.data.draft;
        const draftPos = Array.isArray(d.positionen) ? d.positionen : [];
        const lines = d.extract?.lines ?? [];
        if (draftPos.length > 0) {
            this.positionen = draftPos.map(r => this.mapApiPosition(r));
        } else if (lines.length > 0) {
            this.positionen = lines.map(l => this.mapApiPosition({
                bezeichnung: l.description,
                kosten_netto: l.netto,
                mwstsatz: l.mwstSatz,
                artikel_id: l.artikelId ?? d.suggestedArtikelId,
                artikel_me: (l as any).artikelMe || d.suggestedArtikelMe || null,
                kennzeichen: l.kennzeichen ?? l.kennzeichenHint,
                fibu_fahrzeug_id: l.fibuFahrzeugId,
                tierarzt_id: l.tierarztId,
                tierarzt: l.tierarztName,
                sachkonto: l.sachkonto,
                fibu_aufwand_konto_id: l.fibuAufwandKontoId,
                verteilungsart: l.verteilungsart,
                kostenstelle_suffix: l.kostenstelleSuffix,
            }));
        } else {
            const preise = d.preise ?? [];
            this.positionen =
                preise.length > 0
                    ? preise.map(p => {
                          const pos = this.newPosition();
                          pos.kosten_netto = p.kostenNetto ?? p.kosten_netto ?? 0;
                          pos.mwstsatz = p.mwstsatz ?? 19;
                          if (d.suggestedArtikelId) {
                              pos.artikel_id = d.suggestedArtikelId;
                              pos.artikel_me = d.suggestedArtikelMe;
                          }
                          return pos;
                      })
                    : [this.newPosition()];
        }
        this.syncAutocompleteHelpers();
        this.fahrzeugManuell = this.positionen.some(
            p => !!p.fibu_fahrzeug_id || p.verteilungsart === 'FAHRZEUG_TA' || !!p.sachkonto,
        );
        this.syncKopfFromPositionenIfSingleTa();
    }

    trackPosition = (_: number, pos: GemeinkostenPosition) =>
        pos.kosten_position_id ?? `${pos.position}-${pos.bezeichnung}-${pos.kosten_netto}`;

    trackPagedRow = (_: number, row: { pos: GemeinkostenPosition; i: number }) =>
        this.trackPosition(row.i, row.pos);

    get posPageCount(): number {
        return Math.max(1, Math.ceil((this.positionen?.length || 0) / this.posPageSize));
    }

    get posPageStart(): number {
        return this.posPage * this.posPageSize;
    }

    /** Sichtbare Zeilen der aktuellen Seite (mit globalem Index). */
    get pagedPositionRows(): { pos: GemeinkostenPosition; i: number }[] {
        const start = this.posPageStart;
        return (this.positionen || []).slice(start, start + this.posPageSize).map((pos, j) => ({
            pos,
            i: start + j,
        }));
    }

    get needsPosPagination(): boolean {
        return (this.positionen?.length || 0) > this.posPageSize;
    }

    clampPosPage() {
        const max = this.posPageCount - 1;
        if (this.posPage > max) {
            this.posPage = max;
        }
        if (this.posPage < 0) {
            this.posPage = 0;
        }
    }

    prevPosPage() {
        if (this.posPage > 0) {
            this.posPage -= 1;
            this.scrollFormPaneToTop();
        }
    }

    nextPosPage() {
        if (this.posPage < this.posPageCount - 1) {
            this.posPage += 1;
            this.scrollFormPaneToTop();
        }
    }

    goPosPage(page: number) {
        this.posPage = page;
        this.clampPosPage();
        this.scrollFormPaneToTop();
    }

    private scrollFormPaneToTop() {
        // Nach Seitenwechsel nicht unten am Pager bleiben – Positionen von oben lesen
        setTimeout(() => {
            const el = this.formPane?.nativeElement;
            if (el) {
                el.scrollTop = 0;
            }
        }, 0);
    }

    /**
     * Nach letzter Zeile eines Fahrzeug-Blocks (≥2 Pos.): Trenner für Abgleich.
     * Nur Anzeige – keine Buchungsposition.
     */
    vehicleGroupSumHint(i: number): string | null {
        const p = this.positionen?.[i];
        const fz = Number(p?.fibu_fahrzeug_id) || 0;
        if (!fz) {
            return null;
        }
        const next = this.positionen[i + 1];
        if (next && Number(next.fibu_fahrzeug_id) === fz) {
            return null;
        }
        let start = i;
        while (start > 0 && Number(this.positionen[start - 1]?.fibu_fahrzeug_id) === fz) {
            start -= 1;
        }
        const count = i - start + 1;
        if (count < 2) {
            return null;
        }
        let sum = 0;
        for (let j = start; j <= i; j++) {
            sum += this.signedNetto(this.positionen[j]);
        }
        const fzObj = this.positionFahrzeuge?.[i] as { anzeige?: string; kennzeichen?: string } | null;
        const raw =
            (fzObj?.kennzeichen || '').trim() ||
            (fzObj?.anzeige || '').split('·')[0]?.trim() ||
            (p?.kennzeichen || '').trim() ||
            `FZ ${fz}`;
        const kz = raw.replace(/\s+/g, '-').toUpperCase();
        const sumText = sum.toLocaleString('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return `Summe ${kz} · ${count} Pos. · ${sumText} €`;
    }

    /** Alte Freitext-Summennotizen aus Extract entfernen (Anzeige läuft über Trenner). */
    private stripGroupSumFromBezeichnung(bez: string | null | undefined): string {
        if (!bez) {
            return '';
        }
        return bez.replace(/\s*·\s*Summe\s+[^·]+$/i, '').trim();
    }

    /** Fehlende Konto-Nr nachziehen (auch wenn fibu_aufwand_konto_id schon gesetzt ist). */
    private resolveMissingAufwandKonten() {
        const indices = this.positionen
            .map((p, i) => (!p.konto_nr ? i : -1))
            .filter(i => i >= 0);
        this.resolveKontoBatch(indices, 0);
    }

    private resolveKontoBatch(indices: number[], start: number) {
        const chunk = indices.slice(start, start + 8);
        if (!chunk.length) {
            return;
        }
        chunk.forEach(i => this.resolveAufwandKonto(i));
        if (start + 8 < indices.length) {
            setTimeout(() => this.resolveKontoBatch(indices, start + 8), 50);
        }
    }

    private mapApiPosition(r: any): GemeinkostenPosition {
        const pos = new GemeinkostenPosition();
        const fzId = Number(r.fibu_fahrzeug_id ?? r.fibuFahrzeugId ?? 0) || null;
        const taId = Number(r.tierarzt_id ?? r.tierarztId ?? 0) || null;
        const artId = Number(r.artikel_id ?? r.artikelId ?? 0) || null;
        const aufId = Number(r.fibu_aufwand_konto_id ?? r.fibuAufwandKontoId ?? 0) || null;
        pos.kosten_position_id = r.kosten_position_id ?? r.kostenPositionId;
        pos.position = r.position;
        pos.bezeichnung = this.stripGroupSumFromBezeichnung(r.bezeichnung ?? r.description ?? '');
        pos.artikel_id = artId;
        pos.artikel_me = r.artikel_me ?? r.artikelMe ?? null;
        pos.artikel_buchungskonto = r.artikel_buchungskonto ?? r.buchungskonto ?? null;
        if (artId && !(pos.artikel_me || '').trim()) {
            // Draft-Zeilen haben oft nur artikelId + OCR-Text „Diesel“
            const bez = (r.bezeichnung ?? r.description ?? '').toString();
            if (/\bdiesel\b/i.test(bez) || /\bkraftstoff\b/i.test(bez)) {
                pos.artikel_me = 'Diesel Kraftstoff';
                pos.artikel_buchungskonto = pos.artikel_buchungskonto || '4530';
            } else if (bez.trim()) {
                pos.artikel_me = bez.trim();
            }
        }
        let netto = Number(r.kosten_netto ?? r.kostenNetto) || 0;
        let seite = String(r.buchungsseite ?? r.buchungsSeite ?? 'S').toUpperCase();
        if (netto < 0) {
            seite = 'H';
            netto = Math.abs(netto);
        }
        pos.kosten_netto = netto;
        pos.buchungsseite = seite === 'H' ? 'H' : 'S';
        pos.mwstsatz = normalizeMwstSatz(Number(r.mwstsatz ?? r.mwstSatz ?? 19));
        pos.verteilungsart = r.verteilungsart || (fzId ? 'FAHRZEUG_TA' : this.defaultVerteilungsart());
        pos.fibu_fahrzeug_id = fzId;
        const htaId = Number(r.fibu_honorar_ta_id ?? r.fibuHonorarTaId ?? 0) || null;
        pos.fibu_honorar_ta_id = htaId;
        pos.honorar_ta_bezeichnung = r.honorar_ta_bezeichnung ?? r.honorarTaBezeichnung ?? null;
        if (htaId && pos.verteilungsart !== 'FAHRZEUG_TA') {
            pos.verteilungsart = 'TIERARZT';
        }
        pos.kennzeichen = r.kennzeichen ?? r.kennzeichenHint ?? null;
        pos.fahrzeug_bezeichnung = r.fahrzeug_bezeichnung ?? r.bezeichnungFahrzeug ?? r.tierarztName ?? null;
        pos.kostenstelle_suffix = r.kostenstelle_suffix ?? r.kostenstelleSuffix ?? null;
        pos.sachkonto = r.sachkonto ?? null;
        pos.fibu_aufwand_konto_id = aufId;
        pos.konto_nr = r.konto_nr ?? r.kontoNr;
        pos.tierarzt_id = taId;
        pos.tierarzt = (r.tierarzt ?? r.tierarztName ?? '').toString().trim() || null;
        return pos;
    }

    private defaultVerteilungsart(): GemeinkostenPosition['verteilungsart'] {
        if (this.gemeinkostenTypCtrl.value === 1) {
            return 'LABOR';
        }
        if (this.gemeinkostenTypCtrl.value === 2) {
            return 'TIERARZT';
        }
        return 'ALLGEMEIN';
    }

    private newPosition(): GemeinkostenPosition {
        const pos = new GemeinkostenPosition();
        pos.verteilungsart = this.defaultVerteilungsart();
        pos.mwstsatz = 19;
        if (this.tierarzt?.tierarzt_id && pos.verteilungsart === 'TIERARZT') {
            pos.tierarzt_id = this.tierarzt.tierarzt_id;
        }
        return pos;
    }

    private syncAutocompleteHelpers() {
        this.positionArtikel = this.positionen.map(p =>
            p.artikel_id
                ? ({
                      artikel_id: p.artikel_id,
                      artikel_me: p.artikel_me || p.bezeichnung || `Artikel #${p.artikel_id}`,
                      buchungskonto: p.artikel_buchungskonto,
                  } as unknown as Material)
                : null,
        );
        this.positionFahrzeuge = this.positionen.map(p => {
            if (!p.fibu_fahrzeug_id && !(p.kennzeichen || '').trim()) {
                return null;
            }
            const kz = (p.kennzeichen || '').trim();
            const bez = (p.fahrzeug_bezeichnung || '').trim();
            const anzeige = kz ? (bez ? `${kz} · ${bez}` : kz) : bez || `Fahrzeug #${p.fibu_fahrzeug_id}`;
            return {
                fibu_fahrzeug_id: p.fibu_fahrzeug_id,
                kennzeichen: kz || null,
                bezeichnung: bez || null,
                anzeige,
                kostenstelle_suffix: null,
                tierarzt_id: p.tierarzt_id,
                tierarzt: p.tierarzt,
            };
        });
        this.positionFahrzeuge.forEach((_, i) => this.hydrateFahrzeugKostenarten(i));
        this.positionHonorarTas = this.positionen.map(p => {
            if (!p.fibu_honorar_ta_id) {
                return null;
            }
            return {
                fibu_honorar_ta_id: p.fibu_honorar_ta_id,
                bezeichnung: p.honorar_ta_bezeichnung,
                anzeige: p.honorar_ta_bezeichnung || `Honorar-TA #${p.fibu_honorar_ta_id}`,
                kostenstelle_suffix: null,
                tierarzt_id: p.tierarzt_id,
            };
        });
        this.positionHonorarTas.forEach((_, i) => this.hydrateHonorarKostenarten(i));
        this.positionTieraerzte = this.positionen.map(p => {
            if (!p.tierarzt_id) {
                return null;
            }
            const v = new Tierarzt();
            v.tierarzt_id = p.tierarzt_id;
            v.nachname = p.tierarzt || '';
            v.vorname = '';
            v.titel = '';
            return v;
        });
    }

    onPdfLoad(pdf: { numPages?: number } | Event) {
        const pages = (pdf as { numPages?: number })?.numPages;
        this.totalPages = pages ?? 0;
        this.pdfLoading = false;
        this.pdfErrorRetried = false;
        if (this.page > this.totalPages) {
            this.page = 1;
        }
        this.schedulePdfRelayout(100);
    }

    onPdfPageRendered(): void {
        this.schedulePdfRelayout(30);
    }

    onPdfError(err: unknown) {
        console.error('PDF-Viewer Fehler', err);
        this.pdfLoading = false;
        this.warnings = [
            ...this.warnings.filter(w => !String(w).includes('PDF-Viewer')),
            'PDF-Viewer konnte die Datei nicht anzeigen – bitte „PDF neu laden“ oder „PDF öffnen“ nutzen.',
        ];
        // Einmal auto-Retry mit der anderen Quelle (Bytes ↔ Object-URL).
        if (!this.data.pdfFile || this.pdfErrorRetried) {
            return;
        }
        this.pdfErrorRetried = true;
        if (typeof this.pdfSrc !== 'string') {
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
        }
            this.objectUrl = URL.createObjectURL(this.data.pdfFile);
            this.pdfSrc = null;
            this.cdr.detectChanges();
            setTimeout(() => {
                this.pdfSrc = this.objectUrl;
                this.pdfLoading = true;
                this.cdr.detectChanges();
            }, 0);
            return;
        }
        const applyBytes = (bytes: Uint8Array) => {
            this.pdfBytes = bytes;
            this.pdfSrc = null;
            this.cdr.detectChanges();
            setTimeout(() => {
                this.pdfSrc = bytes;
                this.pdfLoading = true;
                this.cdr.detectChanges();
            }, 0);
        };
        if (this.pdfBytes) {
            applyBytes(this.pdfBytes);
            return;
        }
        this.data.pdfFile.arrayBuffer().then(
            buf => applyBytes(new Uint8Array(buf)),
            () => undefined,
        );
    }

    /** Viewer hart neu starten (Uint8Array bevorzugt). */
    reloadPdf(): void {
        if (!this.data?.pdfFile) {
            this.messageService.infoMessage('Kein PDF vorhanden.');
            return;
        }
        this.pdfErrorRetried = false;
        this.warnings = this.warnings.filter(w => !String(w).includes('PDF-Viewer'));
        this.initPdfViewer();
    }

    private initPdfViewer(): void {
        const file = this.data?.pdfFile;
        if (!file) {
            this.pdfSrc = null;
            this.pdfLoading = false;
            return;
        }
        this.pdfLoading = true;
        this.totalPages = 0;
            this.page = 1;
        // Viewer kurz demontieren, damit ng2-pdf-viewer die neue Quelle sicher nimmt.
        this.pdfSrc = null;
        this.cdr.detectChanges();

        if (!this.objectUrl) {
            this.objectUrl = URL.createObjectURL(file);
        }

        const show = (src: string | Uint8Array) => {
            this.pdfSrc = src;
            this.cdr.detectChanges();
        };

        if (this.pdfBytes) {
            setTimeout(() => show(this.pdfBytes!), 0);
            return;
        }

        file.arrayBuffer().then(
            buf => {
                this.pdfBytes = new Uint8Array(buf);
                show(this.pdfBytes);
            },
            () => {
                // Bytes fehlgeschlagen → Object-URL
                show(this.objectUrl!);
            },
        );
    }

    openPdfInNewTab() {
        const file = this.data?.pdfFile;
        if (!file) {
            this.messageService.infoMessage('Kein PDF vorhanden.');
            return;
        }
        const url = URL.createObjectURL(file);
        window.open(url + '#view=FitH', '_blank');
        // URL später freigeben – Tab braucht den Blob kurz.
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
    }

    prevPage() {
        if (this.page > 1) {
            this.page -= 1;
        }
    }

    nextPage() {
        if (this.page < this.totalPages) {
            this.page += 1;
        }
    }

    setLieferant(s: Supplier) {
        this.supplier = s;
        this.positionen.forEach((_, i) => this.resolveAufwandKonto(i));
    }

    openLieferantPicker(): void {
        const initial = (this.supplier?.bezeichnung || '').trim();
        this.dialog
            .open(NebenkostenLieferantPickerDialogComponent, {
                width: '640px',
                maxWidth: '96vw',
                data: { initialSearch: initial, honorar: this.nurHonorar },
            })
            .afterClosed()
            .subscribe((s: Supplier | null) => {
                if (s) {
                    this.setLieferant(s);
                    this.cdr.detectChanges();
                }
            });
    }

    /** Lieferant aus Draft/Kosten oft nur id+Name – Gegenkonto für 4930.01/4945.01 nachladen. */
    private hydrateSupplierFibu(done?: () => void) {
        const id = this.supplier?.lieferant_id;
        if (!id) {
            done?.();
            return;
        }
        if ((this.supplier as any)?.buchungsgegenkonto) {
            done?.();
            return;
        }
        this.api
            .get(this.apiBaseUrl + 'lieferant/read_one.php', new HttpParams().set('lieferant_id', String(id)))
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.lieferant_id) {
                        this.supplier = Object.assign({} as Supplier, this.supplier, {
                            lieferant_id: rec.lieferant_id,
                            bezeichnung: rec.bezeichnung || this.supplier?.bezeichnung,
                            buchungskonto: rec.buchungskonto,
                            buchungsgegenkonto: rec.buchungsgegenkonto,
                        });
                    }
                    done?.();
                },
                error: () => done?.(),
            });
    }

    setTierarzt(v: Tierarzt) {
        this.tierarzt = v;
        this.onTypChanged();
        if (this.nurHonorar && v?.tierarzt_id) {
            this.lookupHonorarTaByTierarzt(v.tierarzt_id, ta => {
                if (!ta) {
                    return;
                }
                this.positionen.forEach((_, i) => this.setPositionHonorarTa(i, ta));
                this.setGesamtHonorarTa(ta);
            });
        }
    }

    onTypChanged() {
        const art = this.defaultVerteilungsart();
        this.positionen.forEach((p, i) => {
            if (p.verteilungsart !== 'FAHRZEUG_TA') {
                p.verteilungsart = art;
                if (art === 'TIERARZT' && this.tierarzt?.tierarzt_id) {
                    p.tierarzt_id = this.tierarzt.tierarzt_id;
                    this.positionTieraerzte[i] = this.tierarzt;
                }
            }
        });
    }

    setPositionArtikel(i: number, m: Material) {
        this.positionArtikel[i] = m;
        const p = this.positionen[i];
        p.artikel_id = m?.artikel_id ?? null;
        p.artikel_me = m?.artikel_me ?? null;
        p.artikel_buchungskonto = (m as any)?.buchungskonto || null;
        if (m?.artikel_me && !(p.bezeichnung || '').trim()) {
            p.bezeichnung = m.artikel_me;
        }
        const kfzArt = kfzSachkontoFromArtikel(p.artikel_buchungskonto);
        if (p.fibu_fahrzeug_id && kfzArt) {
            p.sachkonto = kfzArt;
            const f = this.positionFahrzeuge?.[i];
            if (f) {
                p.kostenstelle_suffix = kfzSuffixForFahrzeug(f, p.sachkonto);
            }
        }
        if (!this.showFahrzeugFibu(i) && p.fibu_fahrzeug_id == null) {
            p.sachkonto = null;
            if (p.verteilungsart === 'FAHRZEUG_TA') {
                p.verteilungsart = this.defaultVerteilungsart();
            }
        }
        this.resolveAufwandKonto(i);
    }

    get nurHonorar(): boolean {
        return !!this.data?.nurHonorar;
    }

    openPositionArtikelPicker(i: number): void {
        const initial =
            (this.positionen[i]?.bezeichnung || '').trim() ||
            (this.positionArtikel[i]?.artikel_me || '').trim() ||
            '';
        this.dialog
            .open(NebenkostenArtikelPickerDialogComponent, {
                width: '640px',
                maxWidth: '96vw',
                data: { initialSearch: initial, honorar: this.nurHonorar },
            })
            .afterClosed()
            .subscribe((m: Material | null) => {
                if (m) {
                    this.setPositionArtikel(i, m);
                    this.cdr.detectChanges();
                }
            });
    }

    openGesamtArtikelPicker(): void {
        const initial =
            (this.gesamtBezeichnung || '').trim() ||
            (this.gesamtArtikel?.artikel_me || '').trim() ||
            '';
        this.dialog
            .open(NebenkostenArtikelPickerDialogComponent, {
                width: '640px',
                maxWidth: '96vw',
                data: { initialSearch: initial, honorar: this.nurHonorar },
            })
            .afterClosed()
            .subscribe((m: Material | null) => {
                if (m) {
                    this.setGesamtArtikel(m);
                    this.cdr.detectChanges();
                }
            });
    }

    /** Fahrzeug + Kostenart: Heuristik, bereits gesetzt, oder manuell „für Auto“. */
    showFahrzeugFibu(i: number): boolean {
        if (this.nurHonorar) {
            return false;
        }
        if (this.fahrzeugManuell) {
            return true;
        }
        const p = this.positionen[i];
        if (!p) {
            return false;
        }
        return isFibuFahrzeugKontext({
            lieferantName: this.supplier?.bezeichnung,
            artikelId: p.artikel_id,
            artikelMe: p.artikel_me,
            artikelBuchungskonto: p.artikel_buchungskonto,
            bezeichnung: p.bezeichnung,
            kommentar: this.kommentarCtrl.value,
            fibuFahrzeugId: p.fibu_fahrzeug_id,
            sachkonto: p.sachkonto,
            verteilungsart: p.verteilungsart,
        });
    }

    showZeilenTierarzt(i: number): boolean {
        return this.showFahrzeugFibu(i) || this.gemeinkostenTypCtrl.value === 2;
    }

    onFahrzeugManuellChanged() {
        if (!this.fahrzeugManuell) {
            this.positionen.forEach((p, i) => {
                if (!isFibuFahrzeugKontext({
                    lieferantName: this.supplier?.bezeichnung,
                    artikelId: p.artikel_id,
                    artikelMe: p.artikel_me,
                    artikelBuchungskonto: p.artikel_buchungskonto,
                    bezeichnung: p.bezeichnung,
                    kommentar: this.kommentarCtrl.value,
                    fibuFahrzeugId: null,
                    sachkonto: null,
                    verteilungsart: null,
                })) {
                    p.fibu_fahrzeug_id = null;
                    p.kennzeichen = null;
                    p.kostenstelle_suffix = null;
                    p.sachkonto = null;
                    this.positionFahrzeuge[i] = null;
                    if (p.verteilungsart === 'FAHRZEUG_TA') {
                        p.verteilungsart = this.defaultVerteilungsart();
                    }
                    this.resolveAufwandKonto(i);
                }
            });
        }
    }

    onNurGesamtbetragChanged() {
        if (this.nurGesamtbetrag) {
            this.enterGesamtbetragMode();
        } else {
            this.leaveGesamtbetragMode();
        }
    }

    private enterGesamtbetragMode() {
        this.positionenVorGesamt = this.positionen.map(p => Object.assign(new GemeinkostenPosition(), p));
        this.artikelVorGesamt = [...this.positionArtikel];

        const nettoFromExtract = this.extractNetto;
        this.gesamtNetto =
            nettoFromExtract != null && nettoFromExtract > 0 ? nettoFromExtract : this.sumNettoFromPositionen();
        this.gesamtMwstEuro = this.sumMwstFromPositionen();
        if (this.gesamtMwstEuro <= 0 && this.gesamtNetto > 0) {
            const satz = this.positionen[0]?.mwstsatz ?? 19;
            this.gesamtMwstEuro = roundEuro2((this.gesamtNetto * satz) / 100);
        }
        this.gesamtMwstsatz = this.gesamtMwstSatzFromEuro();

        if (this.extractBrutto != null) {
            const diffCents = Math.round((this.extractBrutto - this.gesamtBrutto) * 100);
            if (diffCents !== 0 && Math.abs(diffCents) <= 2) {
                this.gesamtMwstEuro = mwstEuroForTargetBrutto(this.gesamtNetto, this.extractBrutto);
            }
        }

        const firstWithArt = this.positionen.find(p => p.artikel_id);
        // Honorare: nie OCR-Nebenkosten-Artikel aus Position übernehmen (Kopf hat Honorar-Stamm)
        if (this.nurHonorar && this.data.gemeinkosten?.artikel_id) {
            const gArt = this.data.gemeinkosten;
            this.gesamtArtikel = {
                artikel_id: gArt.artikel_id,
                artikel_me: (gArt.artikel_me || '').trim() || 'Honorare und Gehälter',
                buchungskonto: '4760',
            } as unknown as Material;
        } else {
            this.gesamtArtikel = firstWithArt
                ? ({ artikel_id: firstWithArt.artikel_id, artikel_me: firstWithArt.artikel_me || '' } as Material)
                : this.positionArtikel.find(a => !!a) ?? null;
        }
        this.gesamtBezeichnung = this.buildLeistungsFreitext();

        const firstFz = this.positionen.find(p => p.fibu_fahrzeug_id);
        if (firstFz?.fibu_fahrzeug_id) {
            this.gesamtFahrzeug = {
                fibu_fahrzeug_id: firstFz.fibu_fahrzeug_id,
                kennzeichen: firstFz.kennzeichen,
                bezeichnung: firstFz.fahrzeug_bezeichnung,
                anzeige:
                    (firstFz.kennzeichen || '') +
                    (firstFz.fahrzeug_bezeichnung ? ' · ' + firstFz.fahrzeug_bezeichnung : ''),
                kostenstelle_suffix: firstFz.kostenstelle_suffix,
                tierarzt_id: firstFz.tierarzt_id,
            };
            this.gesamtSachkonto = firstFz.sachkonto;
            this.gesamtKostenstelleSuffix = firstFz.kostenstelle_suffix;
            this.gesamtKennzeichen = firstFz.kennzeichen;
            this.gesamtKontoNr = firstFz.konto_nr;
            this.gesamtFibuAufwandKontoId = firstFz.fibu_aufwand_konto_id;
            if (firstFz.tierarzt_id) {
                this.gesamtTierarzt = Object.assign(new Tierarzt(), {
                    tierarzt_id: firstFz.tierarzt_id,
                    nachname: firstFz.tierarzt || '',
                });
            }
            this.fahrzeugManuell = true;
        } else {
            this.gesamtFahrzeug = null;
            this.gesamtSachkonto = null;
            this.gesamtKostenstelleSuffix = null;
            this.gesamtKennzeichen = null;
            this.gesamtKontoNr = null;
            this.gesamtFibuAufwandKontoId = null;
            this.gesamtTierarzt = null;
        }
        this.resolveGesamtKonto();
    }

    /**
     * Freitext = Leistungsinhalt (was war es?), nie „Gesamtbetrag“.
     * Preferiert Positionsbezeichnungen, dann Kommentar, Extract, Artikel, Lieferant.
     */
    private buildLeistungsFreitext(): string {
        const fromPositions = this.positionen
            .map(p => (p.bezeichnung || '').trim())
            .filter(t => t && !/^gesamtbetrag$/i.test(t));
        if (fromPositions.length === 1) {
            return fromPositions[0];
        }
        if (fromPositions.length > 1) {
            const joined = fromPositions.slice(0, 3).join('; ');
            return fromPositions.length > 3 ? joined + ' …' : joined;
        }

        const kommentar = (this.kommentarCtrl.value || '').trim();
        if (kommentar && !/^gesamtbetrag$/i.test(kommentar) && !/^sim_fibu_/i.test(kommentar)) {
            return kommentar.length > 80 ? kommentar.slice(0, 79) + '…' : kommentar;
        }

        const extractLines = (this.data.draft?.extract?.lines ?? [])
            .map(l => (l.description || '').trim())
            .filter(Boolean);
        if (extractLines.length === 1) {
            return extractLines[0];
        }
        if (extractLines.length > 1) {
            const joined = extractLines.slice(0, 3).join('; ');
            return extractLines.length > 3 ? joined + ' …' : joined;
        }

        const artikel = (this.gesamtArtikel?.artikel_me || this.positionArtikel.find(a => a)?.artikel_me || '').trim();
        if (artikel) {
            return artikel;
        }

        const lieferant = (this.supplier?.bezeichnung || '').trim();
        if (lieferant) {
            return `Rechnung ${lieferant}`;
        }

        return 'Nebenkosten';
    }

    private leaveGesamtbetragMode() {
        if (this.positionenVorGesamt?.length) {
            this.positionen = this.positionenVorGesamt.map(p => Object.assign(new GemeinkostenPosition(), p));
            this.positionArtikel = this.artikelVorGesamt ? [...this.artikelVorGesamt] : [];
            this.syncAutocompleteHelpers();
            this.positionen.forEach((_, i) => this.resolveAufwandKonto(i));
        }
        this.positionenVorGesamt = null;
        this.artikelVorGesamt = null;
    }

    private sumNettoFromPositionen(): number {
        return this.positionen.reduce((s, p) => s + this.signedNetto(p), 0);
    }

    get canApplyRabatt(): boolean {
        const r = Number(this.rabattNetto);
        return Number.isFinite(r) && r > 0 && this.sumNettoFromPositionen() > 0 && !this.nurGesamtbetrag;
    }

    private isVersandBezeichnung(text: string): boolean {
        return /\b(versandkosten|versand\s*pauschale|versand|frachtkosten|fracht|shipping|handling|lieferkosten|paketkosten)\b/i.test(
            (text || '').trim(),
        );
    }

    applyRabatt() {
        if (!this.canApplyRabatt) {
            return;
        }
        const sum = this.sumNettoFromPositionen();
        let rabatt = Math.round(Number(this.rabattNetto) * 100) / 100;
        if (rabatt > sum) {
            rabatt = sum;
        }
        if (rabatt <= 0) {
            return;
        }

        this.nettoVorRabatt = this.positionen.map(p => Number(p.kosten_netto) || 0);

        const versandIdx: number[] = [];
        const coreIdx: number[] = [];
        this.positionen.forEach((p, i) => {
            if (this.isVersandBezeichnung(p.bezeichnung || '')) {
                versandIdx.push(i);
            } else {
                coreIdx.push(i);
            }
        });

        if (coreIdx.length === 0) {
            this.messageService.infoMessage('Keine Positionen zum Verteilen (nur Versand?).');
            this.nettoVorRabatt = null;
            return;
        }

        const versandSum = versandIdx.reduce((s, i) => s + (Number(this.positionen[i].kosten_netto) || 0), 0);
        const coreSum = coreIdx.reduce((s, i) => s + (Number(this.positionen[i].kosten_netto) || 0), 0);
        const zielCore = Math.round((sum - rabatt - versandSum) * 100) / 100;

        if (coreSum <= 0) {
            this.messageService.infoMessage('Core-Summe ist 0 – nichts zu verteilen.');
            this.nettoVorRabatt = null;
            return;
        }

        let allocated = 0;
        coreIdx.forEach((i, n) => {
            const old = Number(this.positionen[i].kosten_netto) || 0;
            if (n === coreIdx.length - 1) {
                this.positionen[i].kosten_netto = Math.round((zielCore - allocated) * 100) / 100;
            } else {
                const next = Math.round((old * zielCore) / coreSum * 100) / 100;
                this.positionen[i].kosten_netto = next;
                allocated += next;
            }
        });

        this.rabattNetto = null;
        this.messageService.infoMessage(
            `Rabatt ${rabatt.toFixed(2)} € verteilt – neue Summe ${this.sumNettoFromPositionen().toFixed(2)} €.`,
        );
    }

    undoRabatt() {
        if (!this.nettoVorRabatt?.length || this.nettoVorRabatt.length !== this.positionen.length) {
            return;
        }
        this.positionen.forEach((p, i) => {
            p.kosten_netto = this.nettoVorRabatt![i];
        });
        this.nettoVorRabatt = null;
        this.messageService.infoMessage('Rabatt-Verteilung rückgängig gemacht.');
    }

    private sumMwstFromPositionen(): number {
        return this.positionen.reduce((s, p) => {
            const netto = Number(p.kosten_netto) || 0;
            const satz = Number(p.mwstsatz) || 0;
            return s + (netto * satz) / 100;
        }, 0);
    }

    get gesamtBrutto(): number {
        return roundEuro2((Number(this.gesamtNetto) || 0) + (Number(this.gesamtMwstEuro) || 0));
    }

    get bruttoRundungsDiff(): number | null {
        if (this.extractBrutto == null) {
            return null;
        }
        return roundEuro2(this.extractBrutto - this.gesamtBrutto);
    }

    /** MwSt-% aus Beträgen ableiten (beim Umschalten in Gesamtmodus). */
    private gesamtMwstSatzFromEuro(): number {
        const netto = Number(this.gesamtNetto) || 0;
        const mwst = Number(this.gesamtMwstEuro) || 0;
        if (netto <= 0) {
            return normalizeMwstSatz(this.positionen[0]?.mwstsatz ?? 19);
        }
        return normalizeMwstSatz(Math.round((mwst / netto) * 10000) / 100);
    }

    /** MwSt-% für Persist: gewählter Satz. */
    private gesamtMwstSatz(): number {
        return normalizeMwstSatz(this.gesamtMwstsatz);
    }

    onGesamtNettoChanged() {
        this.gesamtMwstEuro = roundEuro2(((Number(this.gesamtNetto) || 0) * this.gesamtMwstsatz) / 100);
    }

    onGesamtMwstsatzChanged() {
        this.onGesamtNettoChanged();
    }

    onGesamtMwstEuroChanged() {
        const netto = Number(this.gesamtNetto) || 0;
        const mwst = Number(this.gesamtMwstEuro) || 0;
        if (netto <= 0) {
            return;
        }
        const implied = Math.round((mwst / netto) * 10000) / 100;
        const snapped = normalizeMwstSatz(Math.round(implied));
        if (Math.abs(implied - snapped) < 0.15) {
            this.gesamtMwstsatz = snapped;
        }
    }

    onGesamtBruttoChanged(brutto: number) {
        this.gesamtMwstEuro = mwstEuroForTargetBrutto(this.gesamtNetto, brutto);
    }

    adjustBruttoCent(deltaCents: number) {
        this.onGesamtBruttoChanged(roundEuro2(this.gesamtBrutto + deltaCents / 100));
    }

    applyExtractBrutto() {
        if (this.extractBrutto == null) {
            return;
        }
        this.onGesamtBruttoChanged(this.extractBrutto);
    }

    canMwstVomGesamtbetragAbziehen(): boolean {
        const brutto = Number(this.gesamtNetto);
        const mwst = Number(this.gesamtMwstsatz);
        return Number.isFinite(brutto) && brutto !== 0 && Number.isFinite(mwst) && mwst > 0;
    }

    /** Netto-Feld enthält oft Brutto: MwSt herausrechnen. */
    mwstVomGesamtbetragAbziehen() {
        if (!this.canMwstVomGesamtbetragAbziehen()) {
            return;
        }
        const netto = nettoFromBrutto(this.gesamtNetto, this.gesamtMwstsatz);
        if (netto != null) {
            this.gesamtNetto = netto;
            this.onGesamtNettoChanged();
        }
    }

    setGesamtArtikel(m: Material) {
        this.gesamtArtikel = m;
        if (m?.artikel_me && !(this.gesamtBezeichnung || '').trim()) {
            this.gesamtBezeichnung = m.artikel_me;
        }
        this.resolveGesamtKonto();
    }

    setGesamtFahrzeug(f: any) {
        this.gesamtFahrzeug = f;
        if (!f) {
            this.gesamtKennzeichen = null;
            this.gesamtKostenstelleSuffix = null;
            this.gesamtSachkonto = null;
            this.resolveGesamtKonto();
            return;
        }
        this.gesamtKennzeichen = f.kennzeichen;
        if (!this.gesamtSachkonto) {
            this.gesamtSachkonto = defaultKfzSachkonto((this.gesamtArtikel as any)?.buchungskonto);
        }
        this.withGesamtFahrzeugKostenarten(full => {
            const fz = full || f;
            this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(fz, this.gesamtSachkonto);
            if (fz.tierarzt_id) {
                this.gesamtTierarzt = Object.assign(new Tierarzt(), {
                    tierarzt_id: fz.tierarzt_id,
                    titel: fz.tierarzt_titel || '',
                    vorname: fz.tierarzt_vorname || '',
                    nachname: fz.tierarzt_nachname || '',
                });
                this.syncKopfTierarztFromFahrzeug(fz);
            }
            this.resolveGesamtKonto();
        });
    }

    onGesamtKostenartChanged() {
        if (this.gesamtHonorarTa?.fibu_honorar_ta_id) {
            this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(this.gesamtHonorarTa, this.gesamtSachkonto);
            this.resolveGesamtKonto();
            return;
        }
        this.withGesamtFahrzeugKostenarten(f => {
            if (f && this.gesamtSachkonto) {
                this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(f, this.gesamtSachkonto);
            }
            this.resolveGesamtKonto();
        });
    }

    setGesamtHonorarTa(ta: any) {
        this.gesamtHonorarTa = ta;
        if (!ta) {
            this.gesamtKostenstelleSuffix = null;
            this.resolveGesamtKonto();
            return;
        }
        if (!this.gesamtSachkonto) {
            this.gesamtSachkonto = '4780';
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_honorar_ta/read_one.php',
                new HttpParams().set('fibu_honorar_ta_id', String(ta.fibu_honorar_ta_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res || ta;
                    this.gesamtHonorarTa = Object.assign({}, ta, rec);
                    this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(this.gesamtHonorarTa, this.gesamtSachkonto);
                    this.resolveGesamtKonto();
                },
                error: () => {
                    this.gesamtKostenstelleSuffix = kfzSuffixForFahrzeug(ta, this.gesamtSachkonto);
                    this.resolveGesamtKonto();
                },
            });
    }

    setGesamtTierarzt(v: Tierarzt) {
        this.gesamtTierarzt = v;
        if (this.nurHonorar && v?.tierarzt_id) {
            this.lookupHonorarTaByTierarzt(v.tierarzt_id, ta => this.setGesamtHonorarTa(ta));
        }
    }

    private resolveGesamtKonto() {
        this.gesamtKontoNr = null;
        this.gesamtFibuAufwandKontoId = null;
        if (
            (this.gesamtFahrzeug?.fibu_fahrzeug_id || this.gesamtHonorarTa?.fibu_honorar_ta_id) &&
            this.gesamtSachkonto &&
            this.gesamtKostenstelleSuffix
        ) {
            const expected = kfzKontoNr(this.gesamtSachkonto, this.gesamtKostenstelleSuffix);
            this.gesamtKontoNr = expected;
            const params = new HttpParams()
                .set('sachkonto', String(this.gesamtSachkonto).trim())
                .set('kostenstelle_suffix', String(this.gesamtKostenstelleSuffix).trim())
                .set('aktiv', '1')
                .set('limit', '1');
            this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params).subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res?.[0];
                    if (rec) {
                        this.gesamtFibuAufwandKontoId = rec.fibu_konto_id;
                        this.gesamtKontoNr = rec.konto_nr;
                        return;
                    }
                    // Fallback: Lookup über konto_nr (falls sachkonto/suffix am Stamm leer)
                    if (!expected) {
                        return;
                    }
                    this.api
                        .get(
                            this.apiBaseUrl + 'fibu_konto/read.php',
                            new HttpParams().set('search', expected).set('aktiv', '1').set('limit', '5'),
                        )
                        .subscribe({
                            next: (res2: any) => {
                                const hit = (res2?.records || []).find((r: any) => r.konto_nr === expected);
                                if (hit) {
                                    this.gesamtFibuAufwandKontoId = hit.fibu_konto_id;
                                    this.gesamtKontoNr = hit.konto_nr;
                                }
                            },
                        });
                },
            });
            return;
        }
        const kontoNr = ((this.gesamtArtikel as any)?.buchungskonto || '').trim();
        if (!kontoNr) {
            return;
        }
        this.api
            .get(this.apiBaseUrl + 'fibu_konto/read.php', new HttpParams().set('aktiv', '1').set('limit', '5').set('search', kontoNr))
            .subscribe({
                next: (res: any) => {
                    const records: any[] = res?.records || [];
                    const exact =
                        records.find(r => r.konto_nr === kontoNr) ||
                        records.find(r => r.sachkonto === kontoNr && !r.kostenstelle_suffix);
                    if (exact) {
                        this.gesamtFibuAufwandKontoId = exact.fibu_konto_id;
                        this.gesamtKontoNr = exact.konto_nr;
                    } else {
                        this.gesamtKontoNr = kontoNr;
                    }
                },
            });
    }

    setPositionFahrzeug(i: number, f: any) {
        this.positionFahrzeuge[i] = f;
        const p = this.positionen[i];
        if (!f) {
            p.fibu_fahrzeug_id = null;
            p.kennzeichen = null;
            p.kostenstelle_suffix = null;
            p.sachkonto = null;
            if (p.verteilungsart === 'FAHRZEUG_TA') {
                p.verteilungsart = this.defaultVerteilungsart();
            }
            this.resolveAufwandKonto(i);
            return;
        }
        p.fibu_fahrzeug_id = f.fibu_fahrzeug_id;
        p.kennzeichen = f.kennzeichen;
        p.verteilungsart = 'FAHRZEUG_TA';
        if (!p.sachkonto) {
            p.sachkonto = defaultKfzSachkonto(p.artikel_buchungskonto || (this.positionArtikel[i] as any)?.buchungskonto);
        }
        p.kostenstelle_suffix = kfzSuffixForFahrzeug(f, p.sachkonto);
        // TA nur vom Fahrzeug – nie erfinden (Hof/ZBV → leer)
        if (f.tierarzt_id) {
            p.tierarzt_id = f.tierarzt_id;
            p.tierarzt = (f.tierarzt || '').trim();
            const v = new Tierarzt();
            v.tierarzt_id = f.tierarzt_id;
            v.titel = f.tierarzt_titel || '';
            v.vorname = f.tierarzt_vorname || '';
            v.nachname = f.tierarzt_nachname || p.tierarzt || '';
            this.positionTieraerzte[i] = v;
            this.positionTieraerzte = [...this.positionTieraerzte];
        } else {
            p.tierarzt_id = null;
            p.tierarzt = null;
            this.positionTieraerzte[i] = null;
            this.positionTieraerzte = [...this.positionTieraerzte];
        }
        // Flottenbeleg: Zeilen-TA darf Kopf nicht auf „Tierarzt“ umstellen
        this.ensureKopfAllgemeinForPositionTa(f?.tierarzt_id ? Number(f.tierarzt_id) : null);
        this.resolveAufwandKonto(i);
    }

    setPositionHonorarTa(i: number, ta: any) {
        this.positionHonorarTas[i] = ta;
        const p = this.positionen[i];
        if (!ta) {
            p.fibu_honorar_ta_id = null;
            p.kostenstelle_suffix = null;
            this.resolveAufwandKonto(i);
            return;
        }
        p.fibu_honorar_ta_id = ta.fibu_honorar_ta_id;
        p.verteilungsart = 'TIERARZT';
        if (!p.sachkonto) {
            p.sachkonto = '4780';
        }
        this.withHonorarKostenarten(i, full => {
            const rec = full || ta;
            p.kostenstelle_suffix = kfzSuffixForFahrzeug(rec, p.sachkonto);
            if (rec.tierarzt_id) {
                p.tierarzt_id = rec.tierarzt_id;
                p.tierarzt = (rec.tierarzt || '').trim();
                const v = new Tierarzt();
                v.tierarzt_id = rec.tierarzt_id;
                v.titel = rec.tierarzt_titel || '';
                v.vorname = rec.tierarzt_vorname || '';
                v.nachname = rec.tierarzt_nachname || p.tierarzt || '';
                this.positionTieraerzte[i] = v;
                this.positionTieraerzte = [...this.positionTieraerzte];
            }
            this.resolveAufwandKonto(i);
        });
    }

    /**
     * Kopf „Tierarzt“ + TA für Legacy-Statistik (kosten.tierarzt_id / allgemein=0),
     * wenn genau ein Fahrzeug/TA am Beleg. Hof ohne TA → Kopf unverändert.
     * Mehrere TAs (Tank-/Flottenabrechnung) → kein Auto-Switch.
     */
    private syncKopfTierarztFromFahrzeug(f: any) {
        if (!f?.tierarzt_id) {
            return;
        }
        this.tierarzt = Object.assign(new Tierarzt(), {
            tierarzt_id: f.tierarzt_id,
            titel: f.tierarzt_titel || '',
            vorname: f.tierarzt_vorname || '',
            nachname: f.tierarzt_nachname || (f.tierarzt || '').trim(),
        });
        this.gemeinkostenTypCtrl.setValue(2, { emitEvent: false });
    }

    /** Beim Laden: nur bei genau einem TA über alle Positionen Kopf setzen. */
    private syncKopfFromPositionenIfSingleTa() {
        const ids = this.uniquePositionTierarztIds();
        if (ids.length !== 1) {
            if (ids.length > 1) {
                this.gemeinkostenTypCtrl.setValue(0, { emitEvent: false });
                this.tierarzt = null;
            }
            return;
        }
        const id = ids[0];
        const fz = this.positionFahrzeuge.find(f => f?.tierarzt_id === id);
        if (fz) {
            this.syncKopfTierarztFromFahrzeug(fz);
            return;
        }
        const ta = this.positionTieraerzte.find(t => t?.tierarzt_id === id);
        if (ta) {
            this.tierarzt = ta;
            this.gemeinkostenTypCtrl.setValue(2, { emitEvent: false });
        }
    }

    private uniquePositionTierarztIds(): number[] {
        const ids = new Set<number>();
        for (let i = 0; i < this.positionen.length; i++) {
            const id = this.positionTieraerzte[i]?.tierarzt_id ?? this.positionen[i]?.tierarzt_id;
            if (id) {
                ids.add(Number(id));
            }
        }
        return [...ids];
    }

    /** Mehrere Zeilen-TAs oder abweichende Zeilen-TA → Kopf Allgemein (Flotten-/Tankbeleg). */
    private ensureKopfAllgemeinForPositionTa(positionTaId: number | null) {
        const unique = this.uniquePositionTierarztIds();
        const multi = unique.length > 1;
        const differs =
            positionTaId != null &&
            this.gemeinkostenTypCtrl.value === 2 &&
            this.tierarzt?.tierarzt_id != null &&
            Number(this.tierarzt.tierarzt_id) !== positionTaId;
        if (!multi && !differs) {
            return;
        }
        if (this.gemeinkostenTypCtrl.value === 2) {
            this.gemeinkostenTypCtrl.setValue(0, { emitEvent: false });
            this.tierarzt = null;
        }
    }

    setPositionTierarzt(i: number, v: Tierarzt) {
        this.positionTieraerzte[i] = v;
        const p = this.positionen[i];
        p.tierarzt_id = v?.tierarzt_id ?? null;
        p.tierarzt = v ? `${v.titel || ''}${v.vorname || ''} ${v.nachname || ''}`.trim() : null;
        this.ensureKopfAllgemeinForPositionTa(v?.tierarzt_id ? Number(v.tierarzt_id) : null);
        if (this.nurHonorar && v?.tierarzt_id) {
            this.lookupHonorarTaByTierarzt(v.tierarzt_id, ta => this.setPositionHonorarTa(i, ta));
        }
    }

    onKostenartChanged(i: number) {
        const p = this.positionen[i];
        if (p.fibu_fahrzeug_id && p.sachkonto) {
            p.verteilungsart = 'FAHRZEUG_TA';
            this.withFahrzeugKostenarten(i, f => {
                if (f) {
                    p.kostenstelle_suffix = kfzSuffixForFahrzeug(f, p.sachkonto);
                }
                this.resolveAufwandKonto(i);
            });
            return;
        }
        if (p.fibu_honorar_ta_id && p.sachkonto) {
            p.verteilungsart = 'TIERARZT';
            this.withHonorarKostenarten(i, ta => {
                if (ta) {
                    p.kostenstelle_suffix = kfzSuffixForFahrzeug(ta, p.sachkonto);
                }
                this.resolveAufwandKonto(i);
            });
            return;
        }
        this.resolveAufwandKonto(i);
    }

    private hydrateFahrzeugKostenarten(i: number, done?: (f: any) => void) {
        this.withFahrzeugKostenarten(i, done);
    }

    private withFahrzeugKostenarten(i: number, done?: (f: any) => void) {
        const f = this.positionFahrzeuge?.[i];
        if (!f?.fibu_fahrzeug_id) {
            done?.(null);
            return;
        }
        if (f.kostenarten_map !== undefined || Array.isArray(f.kostenarten)) {
            done?.(f);
            return;
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_fahrzeug/read_one.php',
                new HttpParams().set('fibu_fahrzeug_id', String(f.fibu_fahrzeug_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.fibu_fahrzeug_id) {
                        this.positionFahrzeuge[i] = Object.assign({}, f, rec, {
                            kostenarten_map: rec.kostenarten_map ?? '',
                        });
                        this.positionFahrzeuge = [...this.positionFahrzeuge];
                    }
                    done?.(this.positionFahrzeuge[i]);
                },
                error: () => done?.(f),
            });
    }

    private hydrateHonorarKostenarten(i: number, done?: (f: any) => void) {
        this.withHonorarKostenarten(i, done);
    }

    private withHonorarKostenarten(i: number, done?: (f: any) => void) {
        const f = this.positionHonorarTas?.[i];
        if (!f?.fibu_honorar_ta_id) {
            done?.(null);
            return;
        }
        if (f.kostenarten_map !== undefined || Array.isArray(f.kostenarten)) {
            done?.(f);
            return;
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_honorar_ta/read_one.php',
                new HttpParams().set('fibu_honorar_ta_id', String(f.fibu_honorar_ta_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.fibu_honorar_ta_id) {
                        this.positionHonorarTas[i] = Object.assign({}, f, rec, {
                            kostenarten_map: rec.kostenarten_map ?? '',
                        });
                        this.positionHonorarTas = [...this.positionHonorarTas];
                    }
                    done?.(this.positionHonorarTas[i]);
                },
                error: () => done?.(f),
            });
    }

    private lookupHonorarTaByTierarzt(tierarztId: number, done: (ta: any) => void) {
        this.api
            .get(
                this.apiBaseUrl + 'fibu_honorar_ta/read.php',
                new HttpParams().set('tierarzt_id', String(tierarztId)).set('aktiv', '1').set('limit', '1'),
            )
            .subscribe({
                next: (res: any) => done((res?.records || [])[0] || null),
                error: () => done(null),
            });
    }

    private withGesamtFahrzeugKostenarten(done?: (f: any) => void) {
        const f = this.gesamtFahrzeug;
        if (!f?.fibu_fahrzeug_id) {
            done?.(null);
            return;
        }
        if (f.kostenarten_map !== undefined || Array.isArray(f.kostenarten)) {
            done?.(f);
            return;
        }
        this.api
            .get(
                this.apiBaseUrl + 'fibu_fahrzeug/read_one.php',
                new HttpParams().set('fibu_fahrzeug_id', String(f.fibu_fahrzeug_id)),
            )
            .subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res;
                    if (rec?.fibu_fahrzeug_id) {
                        this.gesamtFahrzeug = Object.assign({}, f, rec, {
                            kostenarten_map: rec.kostenarten_map ?? '',
                        });
                    }
                    done?.(this.gesamtFahrzeug);
                },
                error: () => done?.(f),
            });
    }

    /** Aufwandskonto: 1) Fahrzeug+Kostenart (Kfz), sonst 2) Artikel (+ Lieferant-Suffix). */
    resolveAufwandKonto(i: number) {
        if (this.supplier?.lieferant_id && !(this.supplier as any)?.buchungsgegenkonto) {
            this.hydrateSupplierFibu(() => this.resolveAufwandKontoAfterSupplier(i));
            return;
        }
        this.resolveAufwandKontoAfterSupplier(i);
    }

    private resolveAufwandKontoAfterSupplier(i: number) {
        const p = this.positionen[i];

        // ID schon da, nur Anzeige konto_nr fehlt (typisch Draft ohne konto_nr)
        if (p.fibu_aufwand_konto_id && !p.konto_nr) {
            this.api
                .get(
                    this.apiBaseUrl + 'fibu_konto/read.php',
                    new HttpParams().set('fibu_konto_id', String(p.fibu_aufwand_konto_id)),
                )
                .subscribe({
                    next: (res: any) => {
                        const rec = res?.records?.[0] || res?.[0] || res;
                        if (rec?.konto_nr && Number(rec.fibu_konto_id) === Number(p.fibu_aufwand_konto_id)) {
                            p.konto_nr = rec.konto_nr;
                            if (!p.sachkonto && rec.sachkonto) {
                                p.sachkonto = rec.sachkonto;
                            }
                            if (!p.kostenstelle_suffix && rec.kostenstelle_suffix != null) {
                                p.kostenstelle_suffix = String(rec.kostenstelle_suffix);
                            }
                        }
                    },
                });
            return;
        }

        p.konto_nr = null;
        p.fibu_aufwand_konto_id = null;

        if ((p.fibu_fahrzeug_id || p.fibu_honorar_ta_id) && p.sachkonto && p.kostenstelle_suffix) {
            const expected = kfzKontoNr(p.sachkonto, p.kostenstelle_suffix);
            // Sofort anzeigen (auch wenn Stammkonto fehlt) – sonst bleibt „Konto“ leer
            p.konto_nr = expected;
            const params = new HttpParams()
                .set('sachkonto', String(p.sachkonto).trim())
                .set('kostenstelle_suffix', String(p.kostenstelle_suffix).trim())
                .set('aktiv', '1')
                .set('limit', '1');
            this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params).subscribe({
                next: (res: any) => {
                    const rec = res?.records?.[0] || res?.[0];
                    if (rec) {
                        p.fibu_aufwand_konto_id = rec.fibu_konto_id;
                        p.konto_nr = rec.konto_nr;
                        return;
                    }
                    if (!expected) {
                        return;
                    }
                    this.api
                        .get(
                            this.apiBaseUrl + 'fibu_konto/read.php',
                            new HttpParams().set('search', expected).set('aktiv', '1').set('limit', '5'),
                        )
                        .subscribe({
                            next: (res2: any) => {
                                const hit = (res2?.records || []).find((r: any) => r.konto_nr === expected);
                                if (hit) {
                                    p.fibu_aufwand_konto_id = hit.fibu_konto_id;
                                    p.konto_nr = hit.konto_nr;
                                }
                            },
                        });
                },
            });
            return;
        }

        const kontoNr = preferredAufwandKontoNr({
            artikelBuchungskonto: p.artikel_buchungskonto || (this.positionArtikel[i] as any)?.buchungskonto,
            lieferantGegenkonto: this.supplier?.buchungsgegenkonto,
        });
        if (!kontoNr) {
            return;
        }
        const params = new HttpParams().set('aktiv', '1').set('limit', '5');
        this.api.get(this.apiBaseUrl + 'fibu_konto/read.php', params.set('search', kontoNr)).subscribe({
            next: (res: any) => {
                const records: any[] = res?.records || [];
                const exact =
                    records.find(r => r.konto_nr === kontoNr) ||
                    records.find(r => r.sachkonto === kontoNr && !r.kostenstelle_suffix);
                if (exact) {
                    p.fibu_aufwand_konto_id = exact.fibu_konto_id;
                    p.konto_nr = exact.konto_nr;
                    return;
                }
                this.api
                    .get(
                        this.apiBaseUrl + 'fibu_konto/read.php',
                        new HttpParams().set('sachkonto', kontoNr.split('.')[0]).set('aktiv', '1').set('limit', '20'),
                    )
                    .subscribe({
                        next: (res2: any) => {
                            const list: any[] = res2?.records || [];
                            const base = kontoNr.split('.')[0];
                            const hit =
                                list.find(r => r.konto_nr === kontoNr) ||
                                list.find(r => r.konto_nr === `${base}.00`) ||
                                list.find(
                                    r =>
                                        r.sachkonto === base &&
                                        (r.kostenstelle_suffix == null ||
                                            r.kostenstelle_suffix === '' ||
                                            String(r.kostenstelle_suffix) === '00'),
                                );
                            if (hit) {
                                p.fibu_aufwand_konto_id = hit.fibu_konto_id;
                                p.konto_nr = hit.konto_nr;
                            } else {
                                p.konto_nr = kontoNr;
                            }
                        },
                    });
            },
        });
    }

    positionHinzufuegen() {
        this.positionen.push(this.newPosition());
        this.positionArtikel.push(null);
        this.positionFahrzeuge.push(null);
        this.positionHonorarTas.push(null);
        this.positionTieraerzte.push(null);
        this.posPage = this.posPageCount - 1;
        setTimeout(() => {
            const cards = document.querySelectorAll('.position-card');
            const last = cards[cards.length - 1] as HTMLElement | undefined;
            last?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
    }

    positionVerschieben(i: number, delta: number) {
        const j = i + delta;
        if (j < 0 || j >= this.positionen.length) {
            return;
        }
        this.swapAt(this.positionen, i, j);
        this.swapAt(this.positionArtikel, i, j);
        this.swapAt(this.positionFahrzeuge, i, j);
        this.swapAt(this.positionHonorarTas, i, j);
        this.swapAt(this.positionTieraerzte, i, j);
        this.posPage = Math.floor(j / this.posPageSize);
    }

    positionDropped(event: CdkDragDrop<unknown>) {
        if (event.previousIndex === event.currentIndex) {
            return;
        }
        const start = this.posPageStart;
        const from = start + event.previousIndex;
        const to = start + event.currentIndex;
        moveItemInArray(this.positionen, from, to);
        moveItemInArray(this.positionArtikel, from, to);
        moveItemInArray(this.positionFahrzeuge, from, to);
        moveItemInArray(this.positionHonorarTas, from, to);
        moveItemInArray(this.positionTieraerzte, from, to);
    }

    private swapAt<T>(arr: T[], i: number, j: number) {
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }

    positionEntfernen(i: number) {
        this.positionen.splice(i, 1);
        this.positionArtikel.splice(i, 1);
        this.positionFahrzeuge.splice(i, 1);
        this.positionHonorarTas.splice(i, 1);
        this.positionTieraerzte.splice(i, 1);
        if (this.positionen.length === 0) {
            this.positionHinzufuegen();
        }
        this.clampPosPage();
    }

    canMwstVomBetragAbziehen(i: number): boolean {
        const pos = this.positionen[i];
        if (!pos) {
            return false;
        }
        const brutto = Number(pos.kosten_netto);
        const mwst = Number(pos.mwstsatz);
        return Number.isFinite(brutto) && brutto !== 0 && Number.isFinite(mwst) && mwst > 0;
    }

    /** Netto-Feld enthält oft Brutto: MwSt herausrechnen. */
    mwstVomBetragAbziehen(i: number) {
        const pos = this.positionen[i];
        if (!pos || !this.canMwstVomBetragAbziehen(i)) {
            return;
        }
        const netto = nettoFromBrutto(pos.kosten_netto, pos.mwstsatz);
        if (netto != null) {
            pos.kosten_netto = netto;
        }
    }

    close() {
        this.dialogRef.close();
    }

    get extractNetto(): number | null {
        const v = this.data?.draft?.extract?.nettoGesamt;
        return v == null || Number.isNaN(Number(v)) ? null : Number(v);
    }

    get extractBrutto(): number | null {
        const v = this.data?.draft?.extract?.bruttoGesamt;
        return v == null || Number.isNaN(Number(v)) ? null : Number(v);
    }

    get sumNetto(): number {
        if (this.nurGesamtbetrag) {
            return Number(this.gesamtNetto) || 0;
        }
        return this.sumNettoFromPositionen();
    }

    get sumMwst(): number {
        if (this.nurGesamtbetrag) {
            return Number(this.gesamtMwstEuro) || 0;
        }
        return this.sumMwstFromPositionen();
    }

    get sumBrutto(): number {
        return this.sumNetto + this.sumMwst;
    }

    isValid(): boolean {
        if (
            !this.rechnungNummerCtrl.value ||
            !this.datumCtrl.value ||
            !this.leistungsdatumVonCtrl.value ||
            (this.gemeinkostenTypCtrl.value === 2 && !this.tierarzt?.tierarzt_id)
        ) {
            return false;
        }
        if (this.nurGesamtbetrag) {
            const hasArtikel = !!this.gesamtArtikel?.artikel_id;
            const hasText = !!(this.gesamtBezeichnung || '').trim() || !!(this.kommentarCtrl.value || '').trim();
            return (hasArtikel || hasText) && Number(this.gesamtNetto) >= 0 && Number(this.gesamtMwstEuro) >= 0;
        }
        return this.positionen.every(p => {
            const hasArtikel = !!p.artikel_id;
            const hasText = !!(p.bezeichnung || '').trim();
            return (hasArtikel || hasText) && Number(p.kosten_netto) >= 0 && Number(p.mwstsatz) >= 0;
        });
    }

    /** DATEV-Vorschau: Neu (Journal) + Alt (Legacy) aus aktuellen Formularfeldern. */
    openPrimanotaExportVorschau(): void {
        this.dialog.open(NebenkostenPrimanotaVorschauDialogComponent, {
            width: '920px',
            maxWidth: '96vw',
            data: this.buildPrimanotaExportVorschau(),
        });
    }

    private buildPrimanotaExportVorschau(): PrimanotaExportVorschauData {
        return {
            neu: this.buildPrimanotaVorschauNeu(),
            alt: this.buildPrimanotaVorschauAlt(),
            quelle: 'aktuelle Eingabe im Review',
        };
    }

    /** Journal / kompakt_bu: Aufwand je Positions-Konto an Kreditor. */
    private buildPrimanotaVorschauNeu(): PrimanotaExportVorschauVariante {
        const hinweise: string[] = [];
        const gegenkonto = (this.supplier?.buchungskonto || '').trim();
        if (!gegenkonto) {
            hinweise.push('Kein Kreditor-Konto am Lieferanten – Gegenkonto fehlt.');
        }
        if (!this.supplier?.lieferant_id) {
            hinweise.push('Kein Lieferant gewählt.');
        }

        const beleg = (this.rechnungNummerCtrl.value || '').trim();
        const belegdatum = this.formatPrimanotaBelegdatum(this.datumCtrl.value);
        const kopfText = this.buildPrimanotaBuchungstext();

        type Acc = {
            konto: string;
            sollhaben: 'S' | 'H';
            bu: number | null;
            umsatz: number;
            text: string;
        };
        const byKey = new Map<string, Acc>();

        const addPos = (
            konto: string,
            netto: number,
            mwst: number,
            seite: 'S' | 'H',
            text: string,
        ) => {
            const k = (konto || '').trim();
            if (!k) {
                hinweise.push(`Position ohne Aufwandskonto: ${text || '–'}`);
                return;
            }
            const n = Math.abs(Number(netto) || 0);
            const m = Number(mwst) || 0;
            const brutto = Math.round((n + (n * m) / 100) * 100) / 100;
            if (brutto <= 0) {
                return;
            }
            const sh: 'S' | 'H' = seite === 'H' ? 'H' : 'S';
            const bu = this.buSchluesselFromMwst(m);
            const key = `${sh}|${k}|${bu ?? ''}`;
            const prev = byKey.get(key);
            if (prev) {
                prev.umsatz = Math.round((prev.umsatz + brutto) * 100) / 100;
            } else {
                byKey.set(key, {
                    konto: k,
                    sollhaben: sh,
                    bu,
                    umsatz: brutto,
                    text: (text || '').trim() || kopfText,
                });
            }
        };

        if (this.nurGesamtbetrag) {
            const konto =
                (this.gesamtKontoNr || '').trim() ||
                kfzKontoNr(this.gesamtSachkonto, this.gesamtKostenstelleSuffix) ||
                '';
            const text =
                (this.gesamtBezeichnung || '').trim() ||
                (this.gesamtArtikel?.artikel_me || '').trim() ||
                kopfText;
            addPos(konto, Number(this.gesamtNetto) || 0, this.gesamtMwstSatz(), 'S', text);
        } else {
            this.positionen.forEach(p => {
                const konto =
                    (p.konto_nr || '').trim() ||
                    kfzKontoNr(p.sachkonto, p.kostenstelle_suffix) ||
                    (p.sachkonto || '').trim() ||
                    '';
                const text =
                    (p.bezeichnung || '').trim() || (p.artikel_me || '').trim() || kopfText;
                addPos(konto, Number(p.kosten_netto) || 0, Number(p.mwstsatz) || 0, p.buchungsseite || 'S', text);
            });
        }

        const zeilen: PrimanotaExportVorschauZeile[] = Array.from(byKey.values()).map(a => ({
            sollhaben: a.sollhaben,
            umsatz: a.umsatz,
            konto: a.konto,
            gegenkonto,
            bu_schluessel: a.bu,
            belegdatum,
            beleg,
            buchungstext: this.withBelegIdSuffix(a.text),
        }));

        if (!zeilen.length && !hinweise.length) {
            hinweise.push('Keine Positionen mit Betrag vorhanden.');
        }

        return {
            zeilen,
            hinweise: [...new Set(hinweise)],
            beschreibung:
                'Neu (Journal / kompakt_bu): Aufwandskonto je Position (z. B. 4530.33) an Kreditor, Brutto mit BU.',
        };
    }

    /**
     * Legacy `primanota_generieren_lieferanten` (Kosten):
     * Konto = Lieferant.buchungsgegenkonto, Gegenkonto = buchungskonto, je MwSt-Satz.
     */
    private buildPrimanotaVorschauAlt(): PrimanotaExportVorschauVariante {
        const hinweise: string[] = [];
        const konto = (this.supplier?.buchungsgegenkonto || '').trim();
        const gegenkonto = (this.supplier?.buchungskonto || '').trim();
        if (!this.supplier?.lieferant_id) {
            hinweise.push('Kein Lieferant gewählt.');
        }
        if (!konto) {
            hinweise.push('Kein Aufwand-Gegenkonto am Lieferanten (buchungsgegenkonto) – Legacy-Konto fehlt.');
        }
        if (!gegenkonto) {
            hinweise.push('Kein Kreditor-Konto am Lieferanten (buchungskonto).');
        }

        const beleg = (this.rechnungNummerCtrl.value || '').trim();
        const belegdatum = this.formatPrimanotaBelegdatum(this.datumCtrl.value);
        const kommentar = (this.kommentarCtrl.value || '').trim();
        const buchungstext = this.withBelegIdSuffix(kommentar || this.buildPrimanotaBuchungstext());

        type Acc = { mwst: number; sollhaben: 'S' | 'H'; umsatz: number };
        const byKey = new Map<string, Acc>();

        const add = (netto: number, mwst: number, seite: 'S' | 'H') => {
            const n = Math.abs(Number(netto) || 0);
            const m = Math.round(Number(mwst) || 0);
            const brutto = Math.round((n + (n * m) / 100) * 100) / 100;
            if (brutto <= 0) {
                return;
            }
            const sh: 'S' | 'H' = seite === 'H' ? 'H' : 'S';
            const key = `${sh}|${m}`;
            const prev = byKey.get(key);
            if (prev) {
                prev.umsatz = Math.round((prev.umsatz + brutto) * 100) / 100;
            } else {
                byKey.set(key, { mwst: m, sollhaben: sh, umsatz: brutto });
            }
        };

        if (this.nurGesamtbetrag) {
            add(Number(this.gesamtNetto) || 0, this.gesamtMwstSatz(), 'S');
        } else {
            this.positionen.forEach(p => {
                add(Number(p.kosten_netto) || 0, Number(p.mwstsatz) || 0, p.buchungsseite || 'S');
            });
        }

        const zeilen: PrimanotaExportVorschauZeile[] = Array.from(byKey.values()).map(a => ({
            sollhaben: a.sollhaben,
            umsatz: a.umsatz,
            konto,
            gegenkonto,
            bu_schluessel: this.buSchluesselLegacyFromMwst(a.mwst),
            belegdatum,
            beleg,
            buchungstext: buchungstext || this.buildPrimanotaBuchungstext(),
        }));

        if (!zeilen.length && !hinweise.length) {
            hinweise.push('Keine Positionen mit Betrag vorhanden.');
        }

        return {
            zeilen,
            hinweise: [...new Set(hinweise)],
            beschreibung:
                'Alt (Legacy): ein Aufwandskonto vom Lieferanten (Gegenkonto), gruppiert je MwSt – wie früher über kosten_preise.',
        };
    }

    private buSchluesselFromMwst(mwst: number): number | null {
        const m = Math.round(Number(mwst) || 0);
        if (m === 19) {
            return 9;
        }
        if (m === 7) {
            return 8;
        }
        return null;
    }

    /** Legacy gibSchluesselVorsteuer: 0 % → BU 0 (nicht leer). */
    private buSchluesselLegacyFromMwst(mwst: number): number | null {
        const m = Math.round(Number(mwst) || 0);
        if (m === 19) {
            return 9;
        }
        if (m === 7 || m === 9) {
            return 8;
        }
        if (m === 0) {
            return 0;
        }
        return null;
    }

    private formatPrimanotaBelegdatum(raw: unknown): string {
        if (!raw) {
            return '';
        }
        const d = raw instanceof Date ? raw : new Date(raw as string);
        if (Number.isNaN(d.getTime())) {
            return '';
        }
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yy = String(d.getFullYear()).slice(-2);
        return `${dd}${mm}${yy}`;
    }

    private buildPrimanotaBuchungstext(): string {
        const kom = this.stripBelegIdSuffix(this.kommentarCtrl.value ?? '');
        const lief = (this.supplier?.bezeichnung || '').trim();
        const art =
            (this.gesamtArtikel?.artikel_me || '').trim() ||
            (this.positionArtikel?.[0]?.artikel_me || '').trim() ||
            (this.positionen?.[0]?.bezeichnung || '').trim();
        return this.withBelegIdSuffix((kom || lief || art).trim());
    }

    /** Beleg-ID hinten als `#1234` – analog Legacy-Kosten-Primanota, für schnelle Suche. */
    private withBelegIdSuffix(text: string): string {
        const id = this.data?.gemeinkosten?.kosten_id;
        const base = this.stripBelegIdSuffix(text);
        if (!id) {
            return base.substring(0, 250);
        }
        const tag = `#${id}`;
        const room = 250 - tag.length - (base ? 1 : 0);
        const head = base.substring(0, Math.max(0, room)).trimEnd();
        return (head ? `${head} ${tag}` : tag).substring(0, 250);
    }

    /** Auto-Suffix `#kosten_id` nicht im Kommentarfeld speichern – die Primanota hängt es an. */
    private stripBelegIdSuffix(text: string): string {
        const id = this.data?.gemeinkosten?.kosten_id;
        const base = (text || '').trim();
        if (!id) {
            return base;
        }
        const tag = `#${id}`;
        if (base === tag) {
            return '';
        }
        if (base.endsWith(` ${tag}`)) {
            return base.slice(0, -(tag.length + 1)).trimEnd();
        }
        return base;
    }

    toggleBuchungsseite(i: number): void {
        const p = this.positionen[i];
        if (!p) {
            return;
        }
        p.buchungsseite = p.buchungsseite === 'H' ? 'S' : 'H';
    }

    /** Netto mit Vorzeichen: Haben mindert die Summe. */
    signedNetto(p: GemeinkostenPosition): number {
        const n = Number(p?.kosten_netto) || 0;
        return p?.buchungsseite === 'H' ? -Math.abs(n) : Math.abs(n);
    }

    /** Fahrzeug+Kostenart ohne aufgelöstes Aufwandskonto → erwartete Konto-Nr. */
    private findMissingKfzKontoLabel(): string | null {
        if (this.nurGesamtbetrag) {
            if (
                this.gesamtFahrzeug?.fibu_fahrzeug_id &&
                this.gesamtSachkonto &&
                !this.gesamtFibuAufwandKontoId
            ) {
                return (
                    this.gesamtKontoNr ||
                    kfzKontoNr(this.gesamtSachkonto, this.gesamtKostenstelleSuffix) ||
                    this.gesamtSachkonto
                );
            }
            return null;
        }
        for (let i = 0; i < this.positionen.length; i++) {
            const p = this.positionen[i];
            if (p.fibu_fahrzeug_id && p.sachkonto && !p.fibu_aufwand_konto_id) {
                return p.konto_nr || kfzKontoNr(p.sachkonto, p.kostenstelle_suffix) || p.sachkonto;
            }
        }
        return null;
    }

    private buildPositionenPayload(): any[] {
        if (this.nurGesamtbetrag) {
            return [
                {
                    position: 1,
                    bezeichnung:
                        (this.gesamtBezeichnung || '').trim() ||
                        (this.kommentarCtrl.value || '').trim() ||
                        this.buildLeistungsFreitext(),
                    artikel_id: this.gesamtArtikel?.artikel_id || null,
                    kosten_netto: Number(this.gesamtNetto) || 0,
                    mwstsatz: this.gesamtMwstSatz(),
                    verteilungsart: this.gesamtFahrzeug?.fibu_fahrzeug_id
                        ? 'FAHRZEUG_TA'
                        : this.gesamtHonorarTa?.fibu_honorar_ta_id
                          ? 'TIERARZT'
                          : this.defaultVerteilungsart(),
                    fibu_fahrzeug_id: this.gesamtFahrzeug?.fibu_fahrzeug_id || null,
                    fibu_honorar_ta_id: this.gesamtHonorarTa?.fibu_honorar_ta_id || null,
                    sachkonto: this.gesamtSachkonto || null,
                    fibu_aufwand_konto_id: this.gesamtFibuAufwandKontoId || null,
                    tierarzt_id: this.gesamtTierarzt?.tierarzt_id || null,
                },
            ];
        }
        return this.positionen.map((p, idx) => ({
            position: idx + 1,
            bezeichnung: (p.bezeichnung || '').trim() || null,
            artikel_id: p.artikel_id || null,
            kosten_netto: Math.abs(Number(p.kosten_netto) || 0),
            buchungsseite: p.buchungsseite === 'H' ? 'H' : 'S',
            mwstsatz: p.mwstsatz,
            verteilungsart: p.fibu_fahrzeug_id
                ? 'FAHRZEUG_TA'
                : p.fibu_honorar_ta_id
                  ? 'TIERARZT'
                  : p.verteilungsart || this.defaultVerteilungsart(),
            fibu_fahrzeug_id: p.fibu_fahrzeug_id || null,
            fibu_honorar_ta_id: p.fibu_honorar_ta_id || null,
            sachkonto: p.sachkonto || null,
            fibu_aufwand_konto_id: p.fibu_aufwand_konto_id || null,
            tierarzt_id: p.tierarzt_id || null,
        }));
    }

    save() {
        if (!this.isValid() || this.saving) {
            return;
        }
        if (!this.data.gemeinkosten?.kosten_id) {
            this.messageService.infoMessage('Keine Kostenzeile für Review – bitte Bulk/Auto-Commit abwarten.');
            return;
        }
        const missingKfzKonto = this.findMissingKfzKontoLabel();
        if (missingKfzKonto) {
            this.messageService.infoMessage(
                `Kein Konto ${missingKfzKonto} im Kontenrahmen. Bitte fehlende Kfz-Unterkonten anlegen (Migration) und erneut speichern.`,
            );
            return;
        }
        this.saving = true;
        const toIso = (v: any) => (v ? new Date(v).toISOString() : undefined);
        this.saveExistingKosten(this.gemeinkostenTypCtrl.value ?? 0, toIso);
    }

    private saveExistingKosten(typ: number, toIso: (v: any) => string | undefined) {
        const g = this.data.gemeinkosten!;
        const firstArtikel = this.nurGesamtbetrag
            ? this.gesamtArtikel?.artikel_id
            : this.positionen.find(p => p.artikel_id)?.artikel_id;
        const fd = new FormData();
        fd.append('kosten_id', String(g.kosten_id));
        fd.append('scan_review', '0');
        // Review speichert nur Positionen – Freigabe läuft über die Liste.
        // Sonst: freigegeben=1 → Journal-Proc → Duplicate/Fehler, und Listen-Toggle
        // hat früher die FiBu-Positionen per aus_preise wieder auf ALLGEMEIN gesetzt.
        fd.append('freigegeben', '0');
        const runId = g.wawi_run_id || (g.invoice_draft_id ? String(g.invoice_draft_id) : '');
        if (runId) {
            fd.append('wawi_run_id', runId);
        }
        fd.append('kommentar', this.stripBelegIdSuffix(this.kommentarCtrl.value ?? ''));
        fd.append('rechnung_nr', this.rechnungNummerCtrl.value ?? '');
        const positionenPayload = this.buildPositionenPayload();
        fd.append('positionen', JSON.stringify(positionenPayload));
        fd.append(
            'preise',
            JSON.stringify(
                positionenPayload.map(p => ({
                    kosten_netto:
                        p.buchungsseite === 'H'
                            ? -Math.abs(Number(p.kosten_netto) || 0)
                            : Math.abs(Number(p.kosten_netto) || 0),
                    mwstsatz: normalizeMwstSatz(Number(p.mwstsatz)),
                })),
            ),
        );
        if (this.supplier?.lieferant_id) {
            fd.append('lieferant_id', String(this.supplier.lieferant_id));
        }
        if (firstArtikel) {
            fd.append('artikel_id', String(firstArtikel));
        }
        if (typ === 0) {
            fd.append('allgemein', '1');
        }
        if (typ === 1) {
            fd.append('labor', '1');
        }
        if (typ === 2 && this.tierarzt?.tierarzt_id) {
            fd.append('tierarzt_id', String(this.tierarzt.tierarzt_id));
        }
        const datum = toIso(this.datumCtrl.value);
        if (datum) {
            fd.append('datum', datum);
        }
        const lv = toIso(this.leistungsdatumVonCtrl.value);
        if (lv) {
            fd.append('leistungsdatum_von', lv);
        }
        const lb = toIso(this.leistungsdatumBisCtrl.value);
        if (lb) {
            fd.append('leistungsdatum_bis', lb);
        }

        const options = { headers: new HttpHeaders('Phito-Type: fileupload') };
        this.http.post(this.apiBaseUrl + 'kosten/update.php', fd, options).subscribe({
            next: () => {
                this.kiService
                    .logManualEdit({
                        runId: this.data.draft.runId || runId,
                        kostenId: g.kosten_id,
                        typ,
                        artikelId: firstArtikel,
                        lieferantId: this.supplier?.lieferant_id,
                        lieferantName: this.supplier?.bezeichnung,
                        lieferantNameOcr:
                            this.data.draft.extract?.lieferantName ||
                            this.data.draft.suggestedLieferantName ||
                            undefined,
                        tierarztId: typ === 2 ? this.tierarzt?.tierarzt_id : undefined,
                        rechnungNr: this.rechnungNummerCtrl.value,
                        datum: toIso(this.datumCtrl.value),
                        leistungsdatumVon: toIso(this.leistungsdatumVonCtrl.value),
                        leistungsdatumBis: toIso(this.leistungsdatumBisCtrl.value),
                        kommentar: this.kommentarCtrl.value,
                        before: this.beforeSnapshot ?? undefined,
                        after: {
                            header: {
                                lieferantId: this.supplier?.lieferant_id ?? null,
                                lieferantName: this.supplier?.bezeichnung ?? null,
                                artikelId: firstArtikel ?? null,
                                tierarztId: typ === 2 ? this.tierarzt?.tierarzt_id ?? null : null,
                                typ,
                                rechnungNr: this.rechnungNummerCtrl.value,
                                datum: toIso(this.datumCtrl.value),
                                kommentar: this.kommentarCtrl.value,
                                nurGesamtbetrag: this.nurGesamtbetrag,
                            },
                            positionen: positionenPayload,
                        },
                        positionen: positionenPayload.map((p, idx) => ({
                            position: p.position ?? idx + 1,
                            bezeichnung: p.bezeichnung,
                            bezeichnungOcr:
                                this.beforeSnapshot &&
                                Array.isArray((this.beforeSnapshot as any).positionen) &&
                                (this.beforeSnapshot as any).positionen[idx]
                                    ? (this.beforeSnapshot as any).positionen[idx].bezeichnungOcr
                                    : p.bezeichnung,
                            artikelId: p.artikel_id,
                            artikelBezeichnung:
                                this.positionArtikel[idx]?.artikel_me ||
                                this.gesamtArtikel?.artikel_me ||
                                undefined,
                            kosten_netto: Number(p.kosten_netto) || 0,
                            mwstsatz: normalizeMwstSatz(Number(p.mwstsatz)),
                            fibu_fahrzeug_id: p.fibu_fahrzeug_id,
                            kennzeichen: p.kennzeichen ?? this.positionFahrzeuge[idx]?.kennzeichen,
                            sachkonto: p.sachkonto,
                            fibu_aufwand_konto_id: p.fibu_aufwand_konto_id,
                            tierarzt_id: p.tierarzt_id,
                            verteilungsart: p.verteilungsart,
                        })),
                        preise: positionenPayload.map(p => ({
                            kosten_netto: Number(p.kosten_netto) || 0,
                            mwstsatz: normalizeMwstSatz(Number(p.mwstsatz)),
                        })),
                    })
                    .subscribe({
                        error: err => {
                            console.error('Korrektur-Log speichern fehlgeschlagen', err);
                            this.messageService.errorMessage(
                                'Beleg gespeichert, aber Korrektur-Log (Lernbasis) fehlgeschlagen.',
                                err,
                            );
                        },
                    });
                this.saving = false;
                this.messageService.infoMessage(
                    this.data.mode === 'edit' ? 'Gemeinkosten gespeichert.' : 'Scan-Review gespeichert.',
                );
                this.dialogRef.close({ ok: true, kostenId: g.kosten_id });
            },
            error: err => {
                this.saving = false;
                this.messageService.errorMessage('Speichern fehlgeschlagen.', err);
            },
        });
    }
}
